// css imports
import "./assets/css/divStyle.css";
import * as mainStyles from "./assets/css/main.css";
import "./assets/css/attribution.leaflet.css";
import "./assets/css/icons.css";
import "./assets/css/leaflet.css";
import "./assets/css/clusteringMarkers.leaflet.css";
import "./assets/css/gestureHandling.leaflet.min.css";
import "./assets/css/extraMarkers.leaflet.min.css";
import "./assets/css/slideMenu.leaflet.css";
import "./assets/css/fullscreen.leaflet.css";
import "./assets/css/autoComplete.min.css";
import "./assets/css/maplibre-gl.css";
import "./assets/css/multiple-select-vanilla.css";

// JS imports - order is IMPORTANT
import * as L from "leaflet";
import "leaflet-fullscreen";
import "./assets/js/providers.leaflet";
import "./assets/js/attribution.leaflet";
import "./assets/js/loader.leaflet";
import "./assets/js/leaflet.extra-markers";
import "./assets/js/slideMenu.leaflet";
import * as maplibregl from "./assets/js/maplibre-gl";
import "./assets/js/smoothScrollZoom.leaflet";
import "./assets/js/gestureHandling.leaflet";
import { cooperativeGesturesText } from "./assets/js/gestureHandling.leaflet";
import "./assets/js/mapkitMutant";
import autoComplete from "./assets/js/autocomplete";
import Supercluster from "./assets/js/groupingMarkers.leaflet";
import { Loader } from "@googlemaps/js-api-loader"
import { multipleSelect } from 'multiple-select-vanilla';
import { injectCss, injectJs, injectStyle } from './helpers/assets';
import { getImageUrl, getDirectionsUrl, getAddressFormatted } from './helpers/formatting';
import { getCloseBtn, closeLocationsList } from './elements/menu';
import { getContrastYIQ, getLang } from './helpers/common';
import { getGoogleMarkerIcon } from './elements/marker';
import { addFont, updateColors, checkRtlLanguage } from "./helpers/css";
import { hideMapSkeleton, addMapSkeleton } from "./elements/loading";
import { mapDivId, mainDivId, mapStylesUrl, API_URL, CSS_URL } from "./helpers/constants";
import { calculateDistances, getMapCenter } from "./helpers/geo";
import { filterByCurrentMapView, filterLocationsBySearchingPhrase, sortLocations } from "./helpers/locations";
import { extractAddressString, sortAutocompleteResults } from "./helpers/autocomplete";
import { decode } from "./helpers/platforms/wix";
import Bugsnag from '@bugsnag/js'
import BugsnagPerformance from '@bugsnag/browser-performance'

("use strict");

if (typeof String.prototype.replaceAll === "undefined") {
  String.prototype.replaceAll = function (match, replace) {
    return this.replace(new RegExp(match, 'g'), () => replace);
  }
}

// GLOBAL SETTINGS
let L_PREFER_CANVAS = true;

var currentOpenedStoreId = 0;
var openingPopupAction = false;
var markerToOpen = null;
var defaultMarkerStyle = null;
let searchedPlaceData = null;
let shop = window.Shopify.shop;
let tagsCategories = [];
let allowFetchLocations = true;
let tagsSelector = null;
var tags = [];
let menu = null;
var selectedTags = [];
let preselectedTags = [];
let startBounds = null;
let appleToken = "";
let mapboxToken = "";
let limit = 1;
let tempAllLocations = [];
let resetBtn = null;
let blockShowingResetBtn = true;
let locationsTranslations = [];
export let provider = "Progus";
export let showDistanceFromCenter = false;

export let settings = {
  active: 1,
  centerLat: 49.8419,
  centerLon: 24.0315,
  zoom: 2,
  mapHeight: 500,
  titleLayer: {
    url: "https://{s}.tile.osm.org/{z}/{x}/{y}.png",
    attribution:
      '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
  },
  clusteringMarkers: 0,
  showStoresList: 1,
  showTopBar: 1,
  showFilterOption: 1,
  showAllLocations: 0,
  tagsField: 1,
  googleToken: "",
  popupOrder: "",
  listOrder: "",
  zoomOnLocationClick: 14,
  showSortingField: 1,
  design: "default",
  provider: "OpenStreetMap.Mapnik",
  gestureHandling: 1,
  unitDistance: 1,
  defaultOpenStoresList: 1,
  markerIconColor: "#fff",
  markerColor: 15,
  markerIcon: "circle",
  markerShape: 1,
  searchRadiusType: 0,
  searchRadius: 100,
  minNumOfFoundLocations: 1,
  showUserMarker: 0,
  maxZoom: 20,
  tagsOperator: "OR",
  markerStyles: [],
  customFields: [],
  maxStartResults: 100,
  disableClusteringAtZoom: 7,
  mapState: 1,
  listDesignType: 1,
  showGetDirectionsBtn: 1,
  showRouteBtnStyle: "default",
  websiteBtnStyle: "success",
  phoneBtnStyle: "default",
  faxBtnStyle: "danger",
  mailBtnStyle: "info",
  infoBgColor: "#2E72D2",
  openingHoursBgColor: "#FFC453",
  addressBgColor: "#008060",
  popupTextColor: "#000",
  groupingLocationsColor: "#6ECC39",
  mainColor: "#000",
  initialGeolocation: 0,
  geolocation: 1,
  groupsOnList: 1
};

let storeLocatorText = {
  sort_by_distance: "sort by distance",
  sort_by_name: "sort by name",
  sort_by_default: "sort by default",
  no_stores_message: "No stores found",
  reset_results: "Reset",
  searchbar_placeholder: "Search stores near this address",
  filter_results_placeholder: "Filter by store name or address",
  open_website: "OPEN WEBSITE",
  get_directions: "GET DIRECTIONS",
  find_me: "Find me",
  filters: "Filters",
  filters_selected: "filters selected"
};

export let storeLocatorMap = null;
let markersGroup = null;
let currentLocations = [];
let locations = [];
let locationsList = null;
let searchingPhrase = "";
let mapLoader = null;
export let groupingLocationsTextColor = "black";
let isMobile = false;
let currentPositionMarker = null;
export let currentPosition = null;

let clusters = null;
let index = null;

let googleMarkers = [];
let mapLibreMarkers = [];
let googleOpenedPopup = null;
export let listPosition = 0;
let tagsPosition = 0;
let maxListHeight = 0;
let preselectedCities = [];
let closedGroups = []
let newPlacesApi = 0;

function getPreselectedTags() {
  if (window.Progus?.tags) {
    if (window.Progus?.tags[0] && window.Progus?.tags[0] !== 'undefined') {
      return window.Progus.tags;
    }
  }
  return [];
}

function getPreselectedGroups() {
  if (window.Progus?.groups) {
    if (window.Progus?.groups[0] && window.Progus?.groups[0] !== 'undefined') {
      return window.Progus.groups;
    }
  }
  return [];
}

function getPreselectedCities() {
  if (window.Progus?.city) {
    if (window.Progus?.city[0] && window.Progus?.city[0] !== 'undefined') {
      preselectedCities = window.Progus.city.split(",");
    }
  }
  return [];
}
getPreselectedCities();

function onMapkitLoad() {
  L.mapkitMutant({
    type: settings.provider.split(".")[1].toLowerCase(),
    authorizationCallback: function (done) {
      done(appleToken);
    },
    language: getLang(),
  }).addTo(storeLocatorMap);
}

function initBugsnag() {
  Bugsnag.start({ apiKey: 'cbc511d978e21322161f1c6e62c225bc' });
  BugsnagPerformance.start({ apiKey: 'cbc511d978e21322161f1c6e62c225bc' });
  if (shop) Bugsnag.setUser(shop);
}

init();

function init() {
  initBugsnag();
  try {
    if (window.Progus?.platform === "wix") {
      injectJs("/static.parastorage.com/services/js-sdk/1.537.0/js/wix.min.js", undefined, () => {
        log(error, "inject wix.min.js");
      });
    }
    if (document.getElementById(mainDivId)) {
      if (document.getElementById(mainDivId).innerHTML.length == 0) {
        checkRtlLanguage();
        injectStyle(CSS_URL, (error) => {
          log(error, 'inject main.css')
        });
        addMapSkeleton();
        fetchSettings().then(res => {
          if (res) {
            addFont();
            hideMapSkeleton();

            // detect mobile device
            let clientWidth = window.screen.width;
            if (clientWidth <= 768) isMobile = true;

            if (isMobile) {
              listPosition = settings.listPositionMobile;
              tagsPosition = settings.tagsPositionMobile;
              maxListHeight = settings.maxListHeightMobile;
            } else {
              listPosition = settings.listPosition;
              tagsPosition = settings.tagsPosition;
              maxListHeight = settings.maxListHeight;
            }

            if (window?.Progus?.widget) {
              if (listPosition == 1 || listPosition == 2) {
                listPosition = 0;
              }
            }

            if (window.Progus?.height) {
              let margines = 0;
              if (settings.showTopBar) margines = 40;
              if (listPosition == 1 || listPosition == 2) {
                margines += maxListHeight;
                if (settings.showFilterOption) margines += 40;
                margines += 1;
              }
              settings.mapHeight = window.Progus.height - margines;
            }

            if (listPosition == 3) {
              injectCss(`.${mainStyles.menu}{left:unset;right:0} .${mainStyles.showListBtn}{right:0;transform:rotate(180deg)} .leaflet-menu-close-button{transform:rotate(180deg);border-top: 1px solid #eee!important;border-left: 1px solid #eee!important;}`, (err) => {
                log(err, 'inject listPosition===3 css')
              });
            }
            updateColors();

            create();
          } else {
            hideMap();
          }
        })
          .catch(error => {
            log(error, "fetch settings");
          });
      }
    }
  } catch (error) {
    log(error, "init");
  }
}

if (window?.Progus?.viewMode) {
  if (window.Progus.viewMode == "editor") {
    window.addEventListener('resize', function () {
      try {
        const height = Math.max(
          document.documentElement.clientHeight || 0,
          window.innerHeight || 0
        );
        const width = Math.max(
          document.documentElement.clientWidth || 0,
          window.innerWidth || 0
        );
        const contentContainerNode = document.getElementsByClassName(mainStyles.contentContainer)[0];
        if (contentContainerNode) {
          let margines = 0;
          if (settings.showTopBar) margines = 40;
          if (listPosition == 1 || listPosition == 2) {
            margines += maxListHeight;
            if (settings.showFilterOption) margines += 40;
            margines += 1;
          }
          contentContainerNode.style.height = (height - margines) + "px";
        }
      } catch (error) {
        log(error, "resize window event");
      }
    }, true);
  }
}
async function log(error, functionName, additionalInfo = {}) {
  try {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    Bugsnag.notify(error, event => {
      event.context = `${functionName}`;
      event.addMetadata("custom", {
        shop: shop,
        isMobile,
        ...additionalInfo
      });
    });

  } catch (loggingError) {
    console.error("Failed to log error to Bugsnag:", loggingError);
  }
}
async function fetchSettings() {
  const url = new URL(`${API_URL}front/data`);
  url.searchParams.append("shop", shop);
  url.searchParams.append("lang", getLang());
  if (window?.Progus?.city) url.searchParams.append("city", window.Progus.city);
  if (window?.Progus?.country) url.searchParams.append("country", window.Progus.country);
  if (window?.Progus?.state) url.searchParams.append("state", window.Progus.state);
  if (window?.Progus?.zip) url.searchParams.append("zip", window.Progus.zip);
  if (window?.Progus?.address) url.searchParams.append("address", window.Progus.address);
  if (window?.Progus?.name) url.searchParams.append("name", window.Progus.name);
  if (window?.Progus?.groups) url.searchParams.append("groups", window.Progus.groups);

  return await fetch(url.href).then((res) => res.json()).then((res) => {
    if (res && Object.keys(res).length > 0) {
      settings = res.settings;
      newPlacesApi = res.newPlacesApi;
      locationsTranslations = res.locationsTranslations;

      provider = settings.provider.split('.')[0];

      allowFetchLocations = settings.mapBehaviour == 1 ? false : true;

      if (settings.groupingLocationsColor) {
        groupingLocationsTextColor = getContrastYIQ(settings.groupingLocationsColor);
      } else {
        settings.groupingLocationsColor = "#6ECC39";
        groupingLocationsTextColor = getContrastYIQ(settings.groupingLocationsColor);
      }

      if (settings.sortMethod == 1) {
        if (settings.positions) {
          try {
            settings.positions = JSON.parse(settings.positions);
          } catch (e) {
            settings.positions = [];
          }
        } else {
          settings.positions = [];
        }
      } else {
        settings.positions = [];
      }

      if (settings.active) {
        // change default name to default1 - old version
        if (settings.showRouteBtnStyle == "default") settings.showRouteBtnStyle = "default1";
        if (settings.websiteBtnStyle == "default") settings.websiteBtnStyle = "default1";
        if (settings.phoneBtnStyle == "default") settings.phoneBtnStyle = "default1";
        if (settings.faxBtnStyle == "default") settings.faxBtnStyle = "default1";
        if (settings.mailBtnStyle == "default") settings.mailBtnStyle = "default1";

        // popup elements order and design
        if (settings.popupOrder) {
          try {
            settings.popupOrder = JSON.parse(settings.popupOrder);
            if (settings.popupOrder?.length > 0) {
              settings.popupOrder.forEach(el => {
                if (el.a) {
                  el.a = getAlignText(el.a);
                }
              });
            }
          } catch (e) {
            console.log(e);
          }
        }

        // list elements order and design
        if (settings.listOrder) {
          try {
            settings.listOrder = JSON.parse(settings.listOrder);
            if (settings.listOrder?.length > 0) {
              settings.listOrder.forEach(el => {
                if (el.a) {
                  el.a = getAlignText(el.a);
                }
              });
            }
          } catch (e) {
            console.log(e);
          }
        }

        // override old type of marker style if new one exists
        if (res.markerStyles) {
          defaultMarkerStyle = res.markerStyles.find(style => style.selected == 1);
          if (defaultMarkerStyle) {
            settings.markerColor = defaultMarkerStyle.background;
            settings.markerShape = defaultMarkerStyle.shape;
            settings.markerIconColor = defaultMarkerStyle.iconColor;
            settings.markerIcon = defaultMarkerStyle.icon;
          }
        }

        // add custom css code if exists
        if (settings.css) {
          injectCss(settings.css, (err) => {
            log(err, 'inject custom css')
          });
        }

        // set tags
        tags = res.tags;
        if (tags.length) {
          if (tags.find(el => el.priority)) {
            tags = tags.sort((a, b) => b.priority - a.priority);
          }
        }

        // set tags categories
        if (tags.length > 0) {
          for (let tag of tags) {
            if (tag.tagCategories?.length) {
              for (let tagCategory of tag.tagCategories) {
                if (!tagsCategories.find(el => el.id == tagCategory.id)) {
                  tagsCategories.push(tagCategory);
                }
              }
            }
          }
        }

        // add tags if are in url
        if (tags && getPreselectedTags().length) {
          let tagsToSelect = tags.filter(tag => getPreselectedTags().includes(tag.name.toLowerCase()));
          preselectedTags = tags.filter(tag => getPreselectedTags().includes(tag.name.toLowerCase()));
          tags = [];
          tagsToSelect = tagsToSelect.map(tag => tag.id);
          selectedTags = tagsToSelect;
        }

        // set locations limit
        limit = res.limit;

        // if platform is wix check if plan is expired
        if (res.platform === "wix") {
          if (new Date(res.wixExpirationDate) < new Date() && !res.wixAutoRenew) {
            limit = 1;
          }
        }

        appleToken = res.appleToken;

        if (res.mapboxToken) mapboxToken = res.mapboxToken;

        setTranslations(res.translations);
        return true;
      }
    }
    return false;
  }).catch(e => {
    console.log(e);
    log(e, "fetch settings"); return false
  });
}

function showLoader() {
  if (mapLoader) mapLoader._show();
  updateLocationsListState();
}

function hideLoader() {
  if (mapLoader) mapLoader._hide();
}

function filterLocationsByTagsAND(locations) {
  if (locations.length) {
    locations = locations.filter(el => {
      let tagsString = el.tags;
      let locationHasEveryTag = false;
      if (tagsString) {
        let tagsArray = JSON.parse(tagsString);
        if (tagsArray) {
          locationHasEveryTag = selectedTags.every(tag => tagsArray.includes(tag));
        }
      }
      return locationHasEveryTag;
    });
  }
  return locations;
}

function filterLocationsByTagsOR(locations) {
  if (locations.length) {
    locations = locations.filter(el => {
      if (!el.tags) return false;
      let tagsString = el.tags;
      let locationHasOneOfTag = false;
      if (tagsString) {
        let tagsArray = JSON.parse(tagsString);
        if (tagsArray) {
          locationHasOneOfTag = selectedTags.find(tag => tagsArray.includes(tag));
        }
      }
      return !!locationHasOneOfTag;
    });
  }
  return locations;
}

function applyLocationsTranslations() {
  if (locations?.length && getLang()) {
    if (locationsTranslations?.length) {
      locationsTranslations.forEach(translation => {
        if (translation) {
          let locationToUpdate = locations.find(location => location.id === translation.storeId);
          if (locationToUpdate) {
            Object.keys(translation).forEach(function (k) {
              if (translation[k] && translation[k] !== "") locationToUpdate[k] = translation[k];
            });
          }
        }
      });
    }
  }
}

function clearCurrentLocations() {
  currentLocations = [];
  tempAllLocations = [];
  setLocationsContent();
}

async function fetchAllLocations() {
  showLoader();
  return await fetch(`${API_URL}locations?shopId=${settings.shopId}`).then((res) => res.json()).then((res) => {
    locations = res;
    filterAllLocations();
    if (settings.mapState == 1) startBounds = findLocationsBounds();
    applyLocationsTranslations();
    updateLocations();
    if (settings.mapBehaviour == 1) clearCurrentLocations();
    hideLoader();
    if (locations.length == 0) {
      updateLocationsListState("empty");
    }
    return true;
  }).catch(e => {
    log(e, 'fetch all locations');
    updateLocationsListState("error");
    hideLoader();
  });
}

function isLatitude(lat) {
  // Regular expression to validate latitude values
  const latRegex = /^-?([1-8]?[0-9](\.\d+)?|90(\.0+)?)$/;

  // Check if the input matches the regex pattern
  return latRegex.test(lat);
}

function isLongitude(lon) {
  // Regular expression to validate longitude values
  const lonRegex = /^-?((1[0-7][0-9]|0?[0-9]?[0-9])(\.\d+)?|180(\.0+)?)$/;

  // Check if the input matches the regex pattern
  return lonRegex.test(lon);
}

// filter all locations by predefined tags, cities or/and groups
function filterAllLocations() {
  if (locations.length) {
    locations = locations.slice(0, limit);
    locations = locations.filter(location => {
      if (!isLatitude(location.lat) || !isLongitude(location.lon)) return false; // remove locations with wrong lat/lon values
      if (window?.Progus?.country && location.country !== window?.Progus?.country) return false;
      if (window?.Progus?.province && location.province !== window?.Progus?.province) return false;
      if (window?.Progus?.zipCode && location.zipCode !== window?.Progus?.zipCode) return false;
      if (preselectedCities.length && !preselectedCities.some(city => location.city && location.city == city)) return false;
      if (getPreselectedGroups().length && !getPreselectedGroups().some(group => location.groups && location.groups.find(el => el.name === group))) return false;
      if (preselectedTags.length && !preselectedTags.some(tag => location.tags && location.tags.match(new RegExp(tag.id)))) return false;
      return true;
    });
  }
}

function updateGestureHandlingStyle() {
  if (menu) {
    if (menu.style.display != "none" && listPosition == 0) {
      if (listPosition == 0) {
        injectCss(".leaflet-container:after, .gm-style-mot {padding-left: 300px;}");
      }
      if (listPosition == 3) {
        injectCss(".leaflet-container:after, .gm-style-mot {padding-right: 300px;}");
      }
    } else {
      injectCss(".leaflet-container:after, .gm-style-mot {padding-left: 0;padding-right: 0;}");
    }
  }
}

// override text with dafault translations if exist or with user language translations if exist
function setTranslations(translations) {
  var languageTranslation = translations.find((o) => o.lang == getLang());
  var defaultTranslations = translations.find((o) => o.lang == "d");

  setStoreLocatorTextTranslation(defaultTranslations);
  setStoreLocatorTextTranslation(languageTranslation)
}

function setStoreLocatorTextTranslation(translation) {
  if (translation) {
    for (const [key, value] of Object.entries(translation)) {
      if (value) {
        if (key === "customFields" || key === "tags" || key === "tagsCategories" || key === "groups") {
          setCustomFieldsTranslations(value, key);
        } else {
          storeLocatorText[key] = value;
        }
      }
    }
  }
}

function setCustomFieldsTranslations(customFieldsTranslations, prefix = "") {
  customFieldsTranslations = JSON.parse(customFieldsTranslations);
  if (customFieldsTranslations.length > 0) {
    customFieldsTranslations.forEach(customFieldsTranslation => {
      storeLocatorText[prefix + "_" + customFieldsTranslation.id] = customFieldsTranslation.value;
    });
  }
}

function filterLocationsByTags(data) {
  if (selectedTags.length > 0) {
    if (settings.tagsOperator == "AND") {
      return filterLocationsByTagsAND(data);
    } else {
      return filterLocationsByTagsOR(data);
    }
  } else {
    return data;
  }
}

function filterLocations(data) {
  let result = data;
  if (data.length) {
    // filter locations by currently selected tags
    result = filterLocationsByTags(data);

    // filter locations by current map view
    if (!settings.showAllLocations) {
      result = filterByCurrentMapView(result);
    }

    // filter stores by searching phrase
    result = filterLocationsBySearchingPhrase(result, searchingPhrase);

    // caluclate distance to center
    result = calculateDistances(result);
  }
  return result;
}

function setLocationsContent() {
  getStoresListContent();
  updateStoreListListeners();
  updateTopBarListeners();
  lazyLoadStoresListImages();
  showMarkers();
}

// update locations
function updateLocations() {

  if (locations.length && allowFetchLocations) {
    // Filter all locations by tags, current map view and searching phrase
    currentLocations = filterLocations(locations);

    // Disallow updating locations if map behaviour setting is set to "hidden"
    if (settings.mapBehaviour == 1) {
      allowFetchLocations = false;
      tempAllLocations = currentLocations;
    }

    // Update locations list content and map markers based on currentLocations var
    setLocationsContent();
  }

  // if map behaviour is hidden and there are some found locations
  if (tempAllLocations.length && settings.mapBehaviour == 1) {
    currentLocations = filterLocations(tempAllLocations);

    // Update locations list content and map markers based on currentLocations var
    setLocationsContent();
  }

  // If some place has been found by geolocation or autocomplete input, then send request to save event
  if (searchedPlaceData) {
    sendSearchEvent(searchedPlaceData.foundPlace, searchedPlaceData.hasAddress, searchedPlaceData.geolocation);
    searchedPlaceData = null;
  }

}

function resetResults(e) {
  e.stopPropagation();

  if (currentPositionMarker) {
    removeMarker(currentPositionMarker);
  }

  currentPositionMarker = null;
  currentPosition = null;

  blockShowingResetBtn = true;
  openingPopupAction = false;
  hideResetButton();

  if (settings.showTopBar) {
    const input = document.getElementById("progus-store-locator-search-input");
    input.value = "";
    document.getElementById("sl-searchbar-prefix-btn").className = mainStyles.formIconsSearch;
    input.dispatchEvent(new Event("input"));
  }

  showDistanceFromCenter = false;
  if (getPreselectedTags().length === 0) {
    selectedTags = [];
    if (tagsSelector?.uncheckAll) tagsSelector.uncheckAll();
    let tagsCheckboxesContainer = document.getElementsByClassName(mainStyles.tagsContainer)[0];
    if (tagsCheckboxesContainer) {
      tagsCheckboxesContainer.innerHTML = getTagsHtml();
    }
  }

  searchingPhrase = "";
  var searchingPhraseEl = document.getElementById("sl-searching-phrase");
  if (searchingPhraseEl) searchingPhraseEl.value = "";
  onSearchingPhraseChange();

  if (settings.mapBehaviour == 1) {
    clearCurrentLocations();
  }

  resetView();
}

function addClearSearchingPhraseBtn() {
  var searchingPhraseContainerEl = document.getElementsByClassName(mainStyles.searchingPhraseContainer)[0];
  let clearSearchBtn = document.createElement('a');
  clearSearchBtn.className = mainStyles.clearSearchingPhraseBtn;
  clearSearchBtn.href = "#";
  clearSearchBtn.innerHTML = "&times";
  clearSearchBtn.addEventListener("click", e => {
    e.stopPropagation();
    e.preventDefault();
    var searchingPhraseEl = document.getElementById("sl-searching-phrase");
    if (searchingPhraseEl) searchingPhraseEl.value = "";
    onSearchingPhraseChange();
  });
  searchingPhraseContainerEl.appendChild(clearSearchBtn);
}

function onSearchingPhraseChange() {
  if (settings.showFilterOption) {
    var searchingPhraseEl = document.getElementById("sl-searching-phrase");
    searchingPhrase = searchingPhraseEl.value;

    var existingClearSearchBtn = document.getElementsByClassName(mainStyles.clearSearchingPhraseBtn)[0];
    if (searchingPhrase.length > 0 && !existingClearSearchBtn) {
      addClearSearchingPhraseBtn();
    } else {
      if (existingClearSearchBtn && searchingPhrase.length === 0) existingClearSearchBtn.remove();
    }

    updateLocations();
  }
}

window.onProgusStoreLocatorTagClick = function (tag) {
  let id = parseInt(tag.value);
  if (tag.checked) {
    selectedTags.push(id);
  } else {
    var index = selectedTags.indexOf(id);
    if (index !== -1) {
      selectedTags.splice(index, 1);
    }
  }

  updateLocations();
}

function updateStoreListListeners() {
  let storeListElements = document.getElementsByClassName(mainStyles.storeListElement);
  Array.from(storeListElements).forEach((el) => {
    if (!el || typeof el == "undefined") return;
    el.addEventListener("click", onStoreElementClick);
    el.addEventListener("mouseover", onStoreElementMouseOver);
    el.addEventListener("mouseout", onStoreElementMouseOut);

    //Keyboard listener for accessibility
    el.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onStoreElementClick(e);
      }
    });
  });
}

function updateTopBarListeners() {
  let resetResultsBtns = document.getElementsByClassName("sl-reset-results");
  Array.from(resetResultsBtns).forEach((el) => {
    if (!el || typeof el == "undefined") return;
    el.addEventListener("click", resetResults);
  });
}

function getInputFilter() {
  let emptyContainer = document.createElement("div");
  emptyContainer.id = "sl-searching-phrase";
  emptyContainer.className = mainStyles.searchingPhrase;

  switch (settings.showFilterOption) {
    case 2:
    case 1:
      let container = document.createElement("div");
      container.className = mainStyles.searchingPhraseContainer;
      if (listPosition == 1 || listPosition == 2) container.style.width = "100%";
      let filterInput = document.createElement("input");
      filterInput.id = "sl-searching-phrase";
      filterInput.className = mainStyles.searchingPhrase;
      filterInput.placeholder = storeLocatorText.filter_results_placeholder;
      if (settings.showFilterOption == 2) {
        filterInput.placeholder = "";
        filterInput.disabled = "disabled";
      }
      filterInput.addEventListener("input", onSearchingPhraseChange);
      container.appendChild(filterInput);
      return container;
    default:
      if (listPosition == 0 || listPosition == 3) {
        return emptyContainer;
      } else {
        return document.createDocumentFragment();
      }
  }
}

function getTagsField() {
  if (settings.tagsField === 0) return document.createDocumentFragment();
  if (tags.length > 0) {
    let container = document.createElement("div");
    if (settings.tagsField === 2) {
      container.className = mainStyles.tagsContainerSelect;
      let tagsSelector = document.createElement("select");
      tagsSelector.multiple = "multiple";
      tagsSelector.className = "multiple-select full-width";
      tagsSelector.innerHTML = getTagsOptionsHtml();
      container.appendChild(tagsSelector);
    } else {
      container.className = mainStyles.tagsContainer;
      if (settings.tagsPosition === 1) {
        container.classList.add(mainStyles.tagsContainerBoxed);
      }
      container.innerHTML = getTagsHtml();
    }
    return container;
  }
  return document.createDocumentFragment();
}

function getTagsHtml() {
  var html = "";
  if (tagsCategories.length > 0) {
    injectCss(".progus-store-locator-tags-container {flex-direction: column;}");
    for (let category of tagsCategories) {
      let tagsForCategory = tags.filter(el => el.tagCategories.find(el => el.id == category.id));
      if (tagsForCategory.length > 0) {
        let tagCategoryValue = storeLocatorText["tagsCategories_" + category.id] ? storeLocatorText["tagsCategories_" + category.id] : category.name;
        html += `<div class="tag-category-container"><p class="${mainStyles.tagCategory}">${tagCategoryValue}</p>`;
        for (let tag of tagsForCategory) {
          html += getTagHtml(tag);
        }
        html += "</div>";
      }
    }
  } else {
    for (let tag of tags) {
      html += getTagHtml(tag);
    }
  }
  return html;
}

function getTagsOptionsHtml() {
  var html = "";
  if (tagsCategories.length > 0) {
    for (let category of tagsCategories) {
      let tagsForCategory = tags.filter(el => el.tagCategories.find(el => el.id == category.id));
      if (tagsForCategory.length > 0) {
        let tagCategoryValue = storeLocatorText["tagsCategories_" + category.id] ? storeLocatorText["tagsCategories_" + category.id] : category.name;
        html += `<optgroup label="${tagCategoryValue}">`;
        for (let tag of tagsForCategory) {
          html += getTagOption(tag);
        }
        html += "</optgroup>";
      }
    }
  } else {
    for (let tag of tags) {
      html += getTagOption(tag);
    }
  }
  return html;
}

function getTagOption(tag) {
  let tagValue = storeLocatorText["tags_" + tag.id] ? storeLocatorText["tags_" + tag.id] : tag.name;
  return `<option value="${tag.id}">${tagValue}</option>`;
}

function getTagHtml(tag, textColor = null, bgColor = null, borderColor = null, checkbox = true) {
  let isSelectedClass = "";
  if (tag) {
    let tagValue = storeLocatorText["tags_" + tag.id] ? storeLocatorText["tags_" + tag.id] : tag.name;
    let checked = selectedTags.includes(tag.id);
    if (selectedTags.includes(tag.id)) {
      isSelectedClass = mainStyles.tagChecked;
    }
    let style = "";
    if (textColor) {
      style = `color:${textColor};`;
    }
    if (bgColor) {
      style += `background-color:${bgColor};`;
    }
    if (borderColor) {
      style += `border:1px solid ${borderColor};`;
    }
    if (checkbox) {
      let checkboxElement = document.createElement("input");
      checkboxElement.id = `tag-${tag.id}`;
      checkboxElement.value = tag.id;
      checkboxElement.type = "checkbox";
      checkboxElement.setAttribute("onclick", "onProgusStoreLocatorTagClick(this)");
      if (checked) {
        checkboxElement.setAttribute("checked", "");
      }

      let spanElement = document.createElement("span");
      spanElement.innerText = tagValue;

      let labelElement = document.createElement("label");
      labelElement.className = mainStyles.tagCheckbox;
      labelElement.appendChild(checkboxElement);
      labelElement.appendChild(spanElement);

      return labelElement.outerHTML;
    } else {
      return `<div style='${style}' class='${mainStyles.tag} ${isSelectedClass}' data-id='${tag.id}' id='tag-${tag.id}'>${tagValue}</div>`;
    }
  } else {
    return "";
  }
}

function getGroupsFromLocations(data) {
  let result = [];
  let preselectedGroups = getPreselectedGroups();
  for (let location of data) {
    if (location.groups?.length) {
      for (let group of location.groups) {
        if (!result.find(el => el.id === group.id)) {
          if (preselectedGroups.length) {
            if (preselectedGroups.includes(group)) {
              result.push(group);
            }
          } else {
            result.push(group);
          }
        }
      }
    }
  }
  if (result.length) {
    if (result.find(el => el.priority)) {
      return result.sort((a, b) => b.priority - a.priority);
    } else {
      return result.sort((a, b) => a.name.localeCompare(b.name));
    }
  }
  return [];
}

function getStoresByGroup(group, stores) {
  return stores.filter(el => {
    if (!el.groups?.length) return false;
    return !!el.groups.find(elGroup => elGroup.id === group.id);
  });
}

function getStoresWithoutGroup(stores) {
  return stores.filter(el => !el.groups?.length);
}

function locationsListTop() {
  // Create the outermost div for the store list top
  const topDiv = document.createElement('div');
  topDiv.className = mainStyles.storeListTop;

  // Create the input container div
  const inputContainerDiv = document.createElement('div');
  inputContainerDiv.className = mainStyles.storeListTopInputContainer;

  // Add close button and input filter to the input container
  if (listPosition == 0 || listPosition == 3) inputContainerDiv.appendChild(getCloseBtn());
  inputContainerDiv.appendChild(getInputFilter());

  // Append the input container to the top div
  topDiv.appendChild(inputContainerDiv);

  // Conditionally add tags field based on settings
  if (settings.tagsField !== 0 && tagsPosition == 0) {
    topDiv.appendChild(getTagsField());
  }

  return topDiv;
}

function updateLocationsListState(state = "loading") {
  let list = document.getElementById(mainStyles.storeListElements);
  if (list) {
    list.innerHTML = '';
    let container = document.createElement("div");
    container.className = mainStyles.locationsListEmpty;
    switch (state) {
      case "loading":
        let spinner = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
        <circle cx="50" cy="50" fill="none" stroke="#93dbe9" stroke-width="3" r="40" stroke-dasharray="188.49555921538757 64.83185307179586">
          <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="0.46511627906976744s" values="0 50 50;360 50 50" keyTimes="0;1"/>
        </circle></svg>`;
        container.innerHTML = spinner;
        break;
      case "error":
        let text = document.createElement("p");
        text.innerText = "Error occurred. Please try again later.";
        container.appendChild(text);
        break;
      case "empty":
        let html = "";
        html += `<div class='${mainStyles.emptyStoresList}'>`;
        html += `<p>${storeLocatorText.no_stores_message}</p>`;
        if (locations.length > 0 && settings.mapBehaviour != 1) {
          html += `<br><span class='${mainStyles.link} sl-reset-results'><u>${storeLocatorText.reset_results}</u></span><br><br>`;
        }
        html += "</div>";
        list.innerHTML = html;
        break;
    }
    list.appendChild(container);
  }
}

function toggleGroup(groupId, e) {
  const container = document.getElementById(`groupStores-${groupId}`);
  const titleEl = e.target;
  const groupName = titleEl.dataset.groupname;

  if (container.style.display === 'none') {
    container.style.display = 'block';
    titleEl.innerHTML = '▼ ' + groupName;
    closedGroups = closedGroups.filter(id => id !== groupId);
  } else {
    container.style.display = 'none';
    titleEl.innerHTML = '► ' + groupName;
    if (!closedGroups.includes(groupId)) {
      closedGroups.push(groupId);
    }
  }
}
function getStoresListContent() {
  if (locationsList) {
    // init empty html string
    let html = "";

    if (currentLocations.length === 0) {
      updateLocationsListState("empty");
      return;
    }

    if (currentLocations.length > 0) {
      // find groups
      var groups = getGroupsFromLocations(currentLocations);

      // sort stores
      var sortedStores = sortLocations(currentLocations);

      // limit stores
      sortedStores = sortedStores.slice(0, settings.maxStartResults);

      // if groups exists then go through all groups
      if (groups.length && settings.groupsOnList == 1) {
        for (let group of groups) {
          const isClosed = closedGroups.includes(String(group.id));

          let arrowSymbol = isClosed ? '►' : '▼';
          let displayStyle = isClosed ? 'none' : 'block';
          let storesOfGroup = getStoresByGroup(group, sortedStores);
          let groupName = storeLocatorText[`groups_${group.id}`] ? storeLocatorText[`groups_${group.id}`] : group.name;
          html += `<div class='progus-store-locator-store-list-group'>`;
          if (settings.dropdownGroups) { //settings.dropDownGroups
            html += `
              <div class='${mainStyles.storeListGroupTitle} group-title ${mainStyles.storeListGroupPointer}' 
                  data-groupid="${group.id}"
                  data-groupname="${groupName}"
                  data-closed="${isClosed ? 'true' : 'false'}"
                  tabindex="0"
                  role="button"
                  aria-label="Group: ${groupName}">
                  ${arrowSymbol} ${groupName}
              </div>
              <div id="groupStores-${group.id}" style="display: ${displayStyle}">`;
          } else {
            html += `
            <div class='${mainStyles.storeListGroupTitle}'>
              ${groupName}
            </div>
            <div style="display: block;"> `;
          }
          for (let i = 0; i < storesOfGroup.length; i++) {
            const store = storesOfGroup[i];
            const isLast = (i === storesOfGroup.length - 1);
            html += getListElement(store, isLast);
          }
          html += `</div></div>`;
        }
        let storesWithoutGroup = getStoresWithoutGroup(sortedStores);
        for (let store of storesWithoutGroup) {
          html += getListElement(store);
        }
      } else {
        for (let store of sortedStores) {
          html += getListElement(store);
        }
      }
    }

    locationsList.innerHTML = html;

    const groupTitles = locationsList.querySelectorAll(`.${mainStyles.storeListGroupTitle}.group-title`);
    groupTitles.forEach(titleEl => {
      titleEl.addEventListener('click', (e) => {
        const groupId = titleEl.getAttribute('data-groupid');

        toggleGroup(groupId, e);
      });
      //Keyboard listener for accessibility
      titleEl.addEventListener('keydown', (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          const groupId = titleEl.getAttribute('data-groupid');
          toggleGroup(groupId, e);
        }
      });
    });
  }
}

function lazyLoadStoresListImages() {
  if (settings.listDesignType == 1) {
    if ('IntersectionObserver' in window) {
      function handleIntersection(entries) {
        entries.map((entry) => {
          if (entry.isIntersecting) {
            let bg = entry.target.dataset.bgimage;
            entry.target.style.backgroundImage = "url('" + getImageUrl(bg) + "')";
            observer.unobserve(entry.target);
          }
        });
      }

      const headers = document.querySelectorAll(`.${mainStyles.storeListElement}[data-bgimage]`);
      const observer = new IntersectionObserver(
        handleIntersection,
        { rootMargin: "100px" }
      );
      headers.forEach(header => observer.observe(header));
    } else {
      const elements = document.querySelectorAll(`.${mainStyles.storeListElement}[data-bgimage]`);
      elements.forEach(el => {
        let bg = el.dataset.bgimage;
        el.style.backgroundImage = "url('" + getImageUrl(bg) + "')";
      });
    }
  }
}

function getListElementImgStyle(img) {
  if (img && settings.listDesignType == 1) {
    return "background-size: 100% 100px; background-repeat: no-repeat; padding-top: 108px;";
  }
  return "";
}

function getListElement(store, isLast) {
  let result = `<div ${store.imageUrl ? `data-bgimage="${store.imageUrl}"` : ""}
  style='${getListElementImgStyle(store.imageUrl)}'
  class='${mainStyles.storeListElement} ${isLast && mainStyles.storeListElementLast}'
  data-id='${store.id}'
  data-lat='${store.lat}'
  data-lon='${store.lon}'
  tabindex='0'
  role='button'
  aria-label='Store: ${store.name}'>`;
  settings.listOrder.forEach(el => {
    result += getPopupContentElementHtml(el, store, true);
  });
  // distance
  if ((store.d || store.d === 0) && showDistanceFromCenter) {
    let unit = settings.unitDistance ? "miles" : "km";
    result += `<div class="${mainStyles.distance}"><b>${store.d} ${unit}</b></div>`;
  }
  result += "</div>";
  return result;
}

// returns true if the element or one of its parents has the class classname
function hasSomeParentTheClass(element, classname) {
  if (element.className && element.className.split(' ').indexOf(classname) >= 0) return true;
  return element.parentNode && hasSomeParentTheClass(element.parentNode, classname);
}

function showLocationsList() {
  let menu = document.getElementsByClassName(mainStyles.menu)[0];
  if (menu) menu.style.display = "flex";
}

function onStoreElementClick(e) {
  if (hasSomeParentTheClass(e.target, "clickable")) return;
  e.stopPropagation();
  e.preventDefault();
  showResetButton();
  deactivateHoveredElements();
  var target =
    e.target.className == mainStyles.storeListElement
      ? e.target
      : e.target.closest(`.${mainStyles.storeListElement}`);

  var storeId = target.dataset.id;
  var lat = parseFloat(target.dataset.lat);
  var lon = parseFloat(target.dataset.lon);

  if (document.getElementById(mapDivId).offsetWidth <= 600) {
    closeLocationsList();
  }

  // remove old opened marker and create new one
  if (provider != "Google" && provider != "Progus") {
    if (markerToOpen) markerToOpen.closePopup();
    markerToOpen = getMarkerByStoreId(storeId);
  }

  if (settings.provider.split(".")[0] == "Progus") {
    currentOpenedStoreId = storeId;
    setMapView([lat, lon], settings.zoomOnLocationClick);
  } else {
    currentOpenedStoreId = storeId;
    openingPopupAction = false;
    setMapView([lat, lon], settings.zoomOnLocationClick);
  }
}

let leftMarkerPadding = 50;
let rightMarkerPadding = 50;

function bindPopupAndOpenMarker(markerToOpen, storeId = null) {
  if (menu) {
    if (menu.style.display != "none" && listPosition == 0) {
      leftMarkerPadding = 380;
    }
    if (menu.style.display != "none" && listPosition == 3) {
      rightMarkerPadding = 380;
    }
  }

  if (!storeId) storeId = currentOpenedStoreId;
  if (provider == "Google") {
    openGooglePopupByStoreId(storeId);
  } else {
    if (markerToOpen) {
      markerToOpen.unbindPopup();
      markerToOpen.bindPopup(getMarkerPopup(currentLocations.find(s => s.id == storeId)), {
        autoPanPaddingTopLeft: L.point(leftMarkerPadding, 50),
        autoPanPaddingBottomRight: L.point(rightMarkerPadding, 50),
      }).on("popupopen", onPopupOpen).on("popupclose", onPopupClose);
      markerToOpen.openPopup();
    }
  }
}


function onStoreElementMouseOver(e) {
  var target =
    e.target.className == mainStyles.storeListElement
      ? e.target
      : e.target.closest(`.${mainStyles.storeListElement}`);
  const storeId = target.dataset.id;
  const marker = getMarkerByStoreId(storeId);
  if (marker) {
    const icon = getMarkerIconElement(marker);
    if (icon) {
      if (provider === "Google") {
        if (icon?.path) {
          marker.setIcon({
            path: icon.path,
            anchor: icon.anchor,
            labelOrigin: icon.labelOrigin,
            origin: icon.origin,
            fillColor: icon.fillColor,
            fillOpacity: 0.8,
            strokeWeight: icon.strokeWeight,
          });
        }
      } else {
        icon.classList.add(mainStyles.activeMarker);
      }
    }
  }
}

function onStoreElementMouseOut(e) {
  var target =
    e.target.className == mainStyles.storeListElement
      ? e.target
      : e.target.closest(`.${mainStyles.storeListElement}`);
  const storeId = target.dataset.id;
  const marker = getMarkerByStoreId(storeId);
  if (marker) {
    const icon = getMarkerIconElement(marker);
    if (icon) {
      if (provider === "Google") {
        if (icon?.path) {
          marker.setIcon({
            path: icon.path,
            anchor: icon.anchor,
            labelOrigin: icon.labelOrigin,
            origin: icon.origin,
            fillColor: icon.fillColor,
            fillOpacity: 1,
            strokeWeight: icon.strokeWeight,
          });
        }
      } else {
        icon.classList.remove(mainStyles.activeMarker);
      }
    }
  }
}

function getMarkerIconElement(marker) {
  switch (provider) {
    case "Google":
      return marker.getIcon();
    case "Progus":
      return marker._element;
    default:
      return marker._icon;
  }
}

function getMarkerByStoreId(storeId) {
  let marker = null;
  switch (provider) {
    case "Google":
      return googleMarkers.find(marker => marker.storeId == storeId);
    case "Progus":
      return mapLibreMarkers.find(marker => marker?.getElement()?.dataset?.id == storeId);
    default:
      if (markersGroup) {
        markersGroup.eachLayer(function (layer) {
          if (layer.options.id) {
            if (layer.options.id.toString() == storeId.toString()) {
              marker = layer;
            }
          }
        });
      }
  }

  return marker;
}

function findLocationByBrowser(onSuccess, onError) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        onSuccess(position.coords.latitude, position.coords.longitude);
      },
      () => {
        onError();
      }
    );
  } else {
    log('Navigator.geolocation not supported', "findLocationByBrowser", { navigator_geolocation: navigator.geolocation });
    onError();
  }
}

function findLocationByIP(onSuccess, onError) {
  fetch("https://pro.ip-api.com/json/?key=E4UqD9qY4gJrytp&fields=lat,lon,city,regionName,zip,country&lang=en").then((res) => res.json()).then(res => {
    if (res.lat && res.lon) {
      let foundPlace = { center: [res.lon, res.lat] }

      if (res.city || res.country || res.regionName || res.zip) {
        foundPlace.allAddress = {
          country: res.country,
          city: res.city,
          province: res.regionName,
          zipCode: res.zip,
        }
        searchedPlaceData = {
          foundPlace,
          hasAddress: true,
          geolocation: 1,
        }
      }

      let displayName = res.city ? res.city : res.zip ? res.zip : res.regionName ? res.regionName : res.country ? res.country : "";
      onSuccess(res.lat, res.lon, displayName);
    } else {
      onError();
    }
  }).catch(error => {
    onError();
  })
}

function onLocationNotFound() {
  let spinnerBtn = document.getElementById("sl-searchbar-prefix-btn");
  let findLocationBtn = document.getElementById("sl-find-location");
  if (spinnerBtn) spinnerBtn.className = mainStyles.formIconsSearch;
  if (findLocationBtn) findLocationBtn.classList.remove(mainStyles.locateMeClicked);
}

function onLocationFound(lat, lon, displayName = "") {
  let spinnerBtn = document.getElementById("sl-searchbar-prefix-btn");
  let findLocationBtn = document.getElementById("sl-find-location");
  changeUserLocation([lat, lon], displayName);
  if (spinnerBtn) spinnerBtn.className = mainStyles.closeIcon;
  if (findLocationBtn) findLocationBtn.classList.remove(mainStyles.locateMeClicked);
}

function findMyLocationBtnClick() {
  let spinnerBtn = document.getElementById("sl-searchbar-prefix-btn");
  let findLocationBtn = document.getElementById("sl-find-location");
  if (spinnerBtn) spinnerBtn.className = mainStyles.formIconsSpinner;
  if (findLocationBtn) findLocationBtn.classList.add(mainStyles.locateMeClicked);
  switch (settings.geolocation) {
    case 0:
      findLocationByBrowser(onLocationFound, onLocationNotFound);
      break;
    case 1:
      findLocationByIP(onLocationFound, onLocationNotFound);
      break;
    case 2:
      findLocationByBrowser(onLocationFound, () => {
        findLocationByIP(onLocationFound, onLocationNotFound);
      });
      break;
  }

}

function setSearchBarValue(value) {
  let searchBarInput = document.getElementById("progus-store-locator-search-input");
  if (searchBarInput) {
    searchBarInput.value = value;
    if (value.length > 0) {
      let prefixBtn = document.getElementById("sl-searchbar-prefix-btn");
      prefixBtn.className = mainStyles.closeIcon;
    }

    if (settings.showFilterOption == 2) {
      let filterInput = document.getElementById("sl-searching-phrase");
      if (filterInput) {
        if (value.length > 0) {
          filterInput.disabled = false;
          filterInput.placeholder = storeLocatorText.filter_results_placeholder;
        } else {
          filterInput.disabled = "disabled";
          filterInput.placeholder = "";
        }
      }
    }
  }
}

function degrees_to_radians(degrees) {
  var pi = Math.PI;
  return degrees * (pi / 180);
}

function getBoundsFromLatLng(center, radius) {
  // the circumference of the earth in kilometers
  let C = 40075.017;

  // if unit is miles then change radius from km to miles
  if (settings.unitDistance) {
    radius = radius * 1.609344;
  }

  // calculations
  let dY = 360 * radius / C;
  let dX = dY * Math.cos(degrees_to_radians(center[1]));

  // get sw
  let swLat = center[0] - dY;
  let swLon = center[1] - dX;
  if (swLat > 90) swLat = 90;
  if (swLat < -90) swLat = -90;
  if (swLon > 180) swLon = 180;
  if (swLon < -180) swLon = -180;
  let sw = [swLat, swLon];

  // get ne
  let neLat = center[0] + dY;
  let neLon = center[1] + dX;
  if (neLat > 90) neLat = 90;
  if (neLat < -90) neLat = -90;
  if (neLon > 180) neLon = 180;
  if (neLon < -180) neLon = -180;
  let ne = [neLat, neLon];

  return [ne, sw];
}

function distanceFromPointToPoint(lat1, lon1, lat2, lon2, unit) {
  if ((lat1 == lat2) && (lon1 == lon2)) {
    return 0;
  }
  else {
    var radlat1 = Math.PI * lat1 / 180;
    var radlat2 = Math.PI * lat2 / 180;
    var theta = lon1 - lon2;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    if (dist > 1) {
      dist = 1;
    }
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;
    if (unit == "K") { dist = dist * 1.609344 }
    if (unit == "N") { dist = dist * 0.8684 }
    return dist;
  }
}

function getLatLngsOfClosestLocations(center) {
  let latLngsWithDistanceFromCenter = [];
  for (let point of locations) {
    let d = distanceFromPointToPoint(point.lat, point.lon, center[0], center[1], "K");
    latLngsWithDistanceFromCenter.push({ latlng: [point.lat, point.lon], d });
  }

  let sortedClusteredLatLngs = latLngsWithDistanceFromCenter.sort((a, b) => a.d - b.d);
  sortedClusteredLatLngs = sortedClusteredLatLngs.slice(0, settings.minNumOfFoundLocations);
  return sortedClusteredLatLngs;
}

function calculateMidPoint(latLngA, latLngB) {
  function toRadians(degress) {
    return degress * (Math.PI / 180);
  }

  function toDegrees(radians) {
    return (radians * (180 / Math.PI)).toFixed(4);
  }

  const lngDiff = toRadians(latLngB.lon - latLngA.lon);
  const latA = toRadians(latLngA.lat);
  const latB = toRadians(latLngB.lat);
  const lngA = toRadians(latLngA.lon);

  const bx = Math.cos(latB) * Math.cos(lngDiff);
  const by = Math.cos(latB) * Math.sin(lngDiff);

  const latMidway = toDegrees(
    Math.atan2(
      Math.sin(latA) + Math.sin(latB),
      Math.sqrt((Math.cos(latA) + bx) * (Math.cos(latA) + bx) + by * by)
    )
  );
  const lngMidway = toDegrees(lngA + Math.atan2(by, Math.cos(latA) + bx));

  return [parseFloat(latMidway), parseFloat(lngMidway)];
}

function fitBoundsByMidPoint(point, distance) {
  let bounds;
  switch (provider) {
    case "Google":
      let centerSfo = new google.maps.LatLng(point[0], point[1]);
      let circle = new google.maps.Circle({ radius: distance * 1000, center: centerSfo });
      bounds = circle.getBounds();
      storeLocatorMap.fitBounds(bounds, 0);
      break;
    default:
      bounds = getBoundsFromLatLng(point, distance);
      if (bounds) fitBounds(bounds, 0, 15);
      break;
  }
}

function udpateCurrentPositionMarker(latlng) {
  if (!currentPositionMarker) {
    switch (provider) {
      case "Google":
        currentPositionMarker = new google.maps.Marker({
          position: { lat: latlng[0], lng: latlng[1] },
          map: storeLocatorMap,
        });
        break;
      case "Progus":
        currentPositionMarker = new maplibregl.Marker();
        currentPositionMarker.setLngLat([latlng[1], latlng[0]]);
        currentPositionMarker.addTo(storeLocatorMap);
        break;
      default:
        currentPositionMarker = new L.Marker(latlng);
        currentPositionMarker.addTo(storeLocatorMap);
        break;
    }
  } else {
    switch (provider) {
      case "Google":
        currentPositionMarker.setPosition({ lat: latlng[0], lng: latlng[1] });
        break;
      case "Progus":
        currentPositionMarker.setLngLat([latlng[1], latlng[0]]);
        break;
      default:
        currentPositionMarker.setLatLng(latlng);
        break;
    }
  }
}

function removeMarker(marker) {
  switch (provider) {
    case "Google":
      marker.setMap(null);
      break;
    default:
      marker.remove();
      break;
  }
}

function changeUserLocation(latlng, displayName = null, bounds = null) {
  showResetButton();

  currentPosition = latlng;
  if (settings.showUserMarker) {
    udpateCurrentPositionMarker(latlng);
  }

  allowFetchLocations = true;

  // set searching input value to address by latlng value
  if (settings.showTopBar) {
    if (displayName) {
      setSearchBarValue(displayName);
    } else {
      let opts = {
        headers: {
          'accept-language': 'en'
        },
      };
      let url = "https://nominatim.openstreetmap.org/reverse";
      fetch(`${url}?lat=${latlng[0]}&lon=${latlng[1]}&format=json`, opts)
        .then((response) => response.json())
        .then((res) => {
          let city = "";
          if (res.lon && res.lat) {
            let foundPlace = { center: [res.lon, res.lat] }
            if (res.address) {
              if (res.address.city) {
                city = res.address.city;
              } else {
                city = res.address.town;
              }
              foundPlace.allAddress = {
                country: res.address.country,
                city,
                province: res.address.state,
                zipCode: res.address.postcode,
              }
            }
            // for analytics
            searchedPlaceData = {
              foundPlace,
              hasAddress: true,
              geolocation: 1,
            }
          }
          let addressToDisplay = getOneLineAddress(res.address.road, city, "", "", res.address.country);
          if (addressToDisplay) {
            setSearchBarValue(addressToDisplay);
          }
        })
        .catch(error => {
          log(error, "change user location, nominatim");
        });
    }
  }

  // it will cause that when list of stores rerender, there will be distances from center
  showDistanceFromCenter = true;

  switch (settings.searchRadiusType) {
    case 1:
      if (latlng) {
        fitBoundsByMidPoint(latlng, settings.searchRadius);
      }
      break;
    case 2:
      if (latlng) {
        let latlngs = getLatLngsOfClosestLocations(latlng);
        let farthestPoint = latlngs[latlngs.length - 1];
        let farthestPointLatLng = { lat: farthestPoint.latlng[0], lon: farthestPoint.latlng[1] };
        let targetLatLng = { lat: latlng[0], lon: latlng[1] };
        let distance = farthestPoint.d / 2;
        let midPoint = calculateMidPoint(farthestPointLatLng, targetLatLng);
        fitBoundsByMidPoint(midPoint, distance);
      }
      break;
    default:
      if (bounds) {
        fitBounds(bounds, 0, 15);
      } else {
        if (latlng) {
          setMapView(latlng, 12);
        }
      }
      break;
  }

}

function setMapView(latlng, zoom) {
  if (!zoom) zoom = storeLocatorMap.getZoom();
  try {
    if (typeof latlng[0] != "number") latlng[0] = parseFloat(latlng[0]);
    if (typeof latlng[1] != "number") latlng[1] = parseFloat(latlng[1]);
    switch (provider) {
      case "Google":
        storeLocatorMap.setCenter({ lat: latlng[0], lng: latlng[1] });
        storeLocatorMap.setZoom(zoom);
        break;
      case "Progus":
        let leftPadding = 0;
        let rightPadding = 0;
        if (menu) {
          if (menu.style.display != "none" && listPosition == 0) {
            leftPadding = 300;
          }
          if (menu.style.display != "none" && listPosition == 3) {
            rightPadding = 300;
          }
        }
        storeLocatorMap.flyTo({
          center: [latlng[1], latlng[0]],
          zoom,
          duration: 0,
          animate: false,
          padding: { top: 80, bottom: 0, left: leftPadding, right: rightPadding }
        });

        break;
      default:
        storeLocatorMap.setView(L.latLng(latlng[0], latlng[1]), zoom);
        break;
    }
  } catch (e) {
    console.log(e);
  }
}

function isStoresListOpen() {
  let el = document.getElementsByClassName(mainStyles.menu)[0];
  if (el) {
    if (el.style.display === "flex" || el.style.display === "display") {
      return true;
    }
  }
  return false;
}

function getLeftRightPadding() {
  let leftPadding = 0;
  let rightPadding = 0;
  if (isStoresListOpen() && listPosition == 0) leftPadding = 300;
  if (isStoresListOpen() && listPosition == 3) rightPadding = 300;
  return { leftPadding, rightPadding };
}

// bounds: [ne,sw]
function fitBounds(bounds, pad = 0, maxZoom = 20) {
  let ne, sw;
  let { leftPadding, rightPadding } = getLeftRightPadding();
  switch (provider) {
    case "Google":
      // LatLng (lat, lon)
      ne = new google.maps.LatLng(bounds[0][0], bounds[0][1]);
      sw = new google.maps.LatLng(bounds[1][0], bounds[1][1]);
      // LatLngBounds (sw, ne)
      bounds = new google.maps.LatLngBounds(sw, ne);
      let padding = 10;
      storeLocatorMap.fitBounds(bounds, { left: padding, right: padding, top: padding, bottom: padding });
      break;
    case "Progus":
      ne = L.latLng(bounds[0][0], bounds[0][1]);
      sw = L.latLng(bounds[1][0], bounds[1][1]);
      let tempBounds = L.latLngBounds(ne, sw).pad(pad);
      ne = tempBounds.getNorthEast();
      sw = tempBounds.getSouthWest();
      storeLocatorMap.fitBounds([[ne.lng, ne.lat], [sw.lng, sw.lat]], {
        padding: { left: leftPadding, right: rightPadding },
        linear: true
      });
      break;
    default:
      ne = L.latLng(bounds[0][0], bounds[0][1]);
      sw = L.latLng(bounds[1][0], bounds[1][1]);
      bounds = L.latLngBounds(ne, sw);
      storeLocatorMap.fitBounds(bounds.pad(pad), { maxZoom, paddingTopLeft: [leftPadding, 0], paddingBottomRight: [rightPadding, 0] });
      break;
  }
}

function getSearchBarBtnIcon(ic = "compass", color = "#0066cc") {
  const icon = document.createElement("i");
  icon.className = `sl-ic-1-${ic}`;
  icon.style.fontFamily = "icomoon !important";
  icon.style.color = color;
  return icon;
}

function getSearchBarBtnText(textColor = "#000") {
  const result = document.createElement("span");
  result.innerHTML = storeLocatorText.find_me;
  result.style.color = textColor;
  return result;
}

function buildSearchBarBtn(container) {
  container.innerHTML = "";
  if (settings.searchBarBtn) {
    const { icon, showText, bgColor, color } = JSON.parse(settings.searchBarBtn);
    if (icon || showText) {
      if (bgColor) {
        container.style.backgroundColor = bgColor;
        container.classList.add(mainStyles.locateBtnFull);
      }
      if (icon) {
        container.appendChild(getSearchBarBtnIcon(icon, color));
      }
      if (showText) {
        container.appendChild(getSearchBarBtnText(color))
      }
    }
  } else {
    container.appendChild(getSearchBarBtnIcon());
  }
}

function getTobBarNode() {
  // create top bar input
  const topBarInputNode = document.createElement("input");
  topBarInputNode.setAttribute("autocomplete", "off");
  topBarInputNode.id = "progus-store-locator-search-input";
  topBarInputNode.type = "text";
  topBarInputNode.placeholder = storeLocatorText.searchbar_placeholder;

  const topBarInputList = document.createElement('ul')
  topBarInputList.id = "progus-store-locator-input-list";
  topBarInputList.className = mainStyles.inputList;

  // create top bar input prefix
  const topBarInputPrefixNode = document.createElement("div");
  topBarInputPrefixNode.className = mainStyles.inputPrefix;
  const topBarInputPrefixIconNode = document.createElement("span");
  topBarInputPrefixIconNode.className = mainStyles.formIconsSearch;
  topBarInputPrefixIconNode.id = "sl-searchbar-prefix-btn";
  topBarInputPrefixIconNode.setAttribute('aria-label', 'Searchbar prefix');
  topBarInputPrefixNode.append(topBarInputPrefixIconNode);
  topBarInputPrefixIconNode.onclick = (e) => {
    if (e.target.className === "progus-store-locator-close-icon") {
      resetResults(e);
    }
  }

  // create top bar input suffix
  const topBarInputSuffixNode = document.createElement("div");
  topBarInputSuffixNode.id = "sl-find-location";
  topBarInputSuffixNode.className = mainStyles.inputSuffix;
  topBarInputSuffixNode.addEventListener("click", findMyLocationBtnClick);
  topBarInputSuffixNode.setAttribute("aria-label", "Find stores near me");
  buildSearchBarBtn(topBarInputSuffixNode);

  // create top bar
  const topBarNode = document.createElement("div");
  topBarNode.className = mainStyles.topBar;
  topBarNode.appendChild(topBarInputNode);
  topBarNode.appendChild(topBarInputPrefixNode);
  topBarNode.appendChild(topBarInputSuffixNode);
  topBarNode.appendChild(topBarInputList);

  topBarInputNode.addEventListener("input", () => {
    let value = document.getElementById("progus-store-locator-search-input").value;
    let prefixBtn = document.getElementById("sl-searchbar-prefix-btn");
    if (value.length > 0) {
      prefixBtn.className = mainStyles.closeIcon;
    } else {
      prefixBtn.className = mainStyles.formIconsSearch;
    }
  });

  return topBarNode;
}

function getMenu(fullWidth = false) {
  const menuNode = document.createElement("div");
  menuNode.className = mainStyles.menu;
  if (fullWidth) menuNode.classList.add(mainStyles.menuFullWidth);
  menuNode.appendChild(locationsListTop());

  const locationsNode = document.createElement("div");
  locationsNode.id = mainStyles.storeListElements;
  locationsList = locationsNode;
  if (listPosition != 0 && listPosition != 3 && maxListHeight > 0) {
    locationsNode.style.maxHeight = maxListHeight + "px";
  }
  updateLocationsListState('loading');
  menuNode.appendChild(locationsNode);
  menu = menuNode;

  return menuNode;
}

function getMapNode() {
  const mapContainerNode = document.createElement("div");
  mapContainerNode.className = mainStyles.mapContainer;
  mapContainerNode.style.height = "100%";
  mapContainerNode.id = mapDivId;
  return mapContainerNode;
}

function getLocationsListHandler() {
  const handler = document.createElement("div");
  handler.className = mainStyles.showListBtn;
  const handlerArrow = document.createElement("span");
  handlerArrow.className = "sl-ic-1-chevron-right";
  handler.append(handlerArrow);
  handler.onclick = () => {
    showLocationsList();
  }
  return handler;
}

function getContentContainerNode() {
  const contentContainerNode = document.createElement("div");
  contentContainerNode.className = mainStyles.contentContainer;

  contentContainerNode.style.height = settings.mapHeight + "px";

  contentContainerNode.setAttribute("searchbar", settings.showTopBar);
  if (settings.showStoresList
    && (listPosition == 0 || listPosition == 3)
  ) {
    contentContainerNode.appendChild(getMenu());
    contentContainerNode.appendChild(getLocationsListHandler());
  }
  contentContainerNode.appendChild(getMapNode());
  return contentContainerNode;
}

function handleDefaultOpenLocationsList() {
  switch (settings.defaultOpenStoresList) {
    case 1:
      if (
        document.getElementsByClassName(mainStyles.contentContainer)[0].offsetWidth >
        600
      ) {
        showLocationsList();
      }
      break;
    case 2:
      showLocationsList();
      break;
  }
}

function resetMapControl() {
  let controlBtnType = 'a';
  if (provider === "Google" || provider === "Progus") {
    controlBtnType = 'button';
  }

  const controlButton = document.createElement(controlBtnType);
  if (provider === "Google") {
    controlButton.className = "googlemaps-reset-btn";
  }
  controlButton.title = 'Reset';
  controlButton.type = 'button';

  if (provider === "Google" || provider === "Progus") {
    let content = document.createElement('div');
    content.className = "googlemaps-reset-btn-content";
    if (provider === "Progus") {
      content.className += " maplibregl-ctrl-icon";
      content.style.opacity = 1;
    }
    controlButton.appendChild(content);
  }

  // Setup the click event listeners: simply set the map to Chicago.
  controlButton.addEventListener('click', (e) => {
    resetResults(e);
  });

  return controlButton;
}

function hideResetButton() {
  if (!resetBtn) return;
  resetBtn.style.display = "none";
}

function showResetButton() {
  if (!resetBtn) return;
  resetBtn.style.display = "block";
}

function addGoogleResetButton() {
  resetBtn = document.createElement('div');
  resetBtn.className = "googlemaps-reset-btn-container";
  const resetControl = resetMapControl();
  resetBtn.appendChild(resetControl);

  let resetControlPosition = google.maps.ControlPosition.RIGHT_BOTTOM;
  if (listPosition == 3) {
    resetControlPosition = google.maps.ControlPosition.LEFT_BOTTOM;
  }
  storeLocatorMap.controls[resetControlPosition].push(resetBtn);
}

let suggestionsData = [];
let highlightedIndex = -1;

function highlightFormattableText(formattableText) {
  if (!formattableText) return "";
  const { text, matches } = formattableText;
  if (!text) return "";
  if (!matches || matches.length === 0) {
    return text;
  }

  let result = "";
  let lastIndex = 0;

  matches.forEach(({ startOffset, endOffset }) => {
    result += text.substring(lastIndex, startOffset);
    result += `<b>${text.substring(startOffset, endOffset)}</b>`;
    lastIndex = endOffset;
  });

  result += text.substring(lastIndex);
  return result;
}

function initPlacesAutocomplete() {
  const input = document.getElementById("progus-store-locator-search-input");
  const suggestionListEl = document.getElementById("progus-store-locator-input-list");

  let sessionToken = new google.maps.places.AutocompleteSessionToken();

  async function selectSuggestion(index) {
    if (index < 0 || index >= suggestionsData.length) return;

    const suggestion = suggestionsData[index];
    const place = suggestion.placePrediction.toPlace();

    await place.fetchFields({
      fields: ["addressComponents", "formattedAddress", "viewport", "location"],
    });
    suggestionListEl.innerHTML = "";

    const foundPlaceObj = {
      address_components: place.addressComponents,
      formatted_address: place.formattedAddress,
      geometry: {
        location: place.location,
        viewport: place.viewport
      }
    };
    onAutocompleteAddressSelection(foundPlaceObj);
  }

  function highlightCurrentItem() {
    const allLi = suggestionListEl.querySelectorAll("li");
    allLi.forEach(li => li.classList.remove(mainStyles.liActive));

    if (highlightedIndex >= 0 && highlightedIndex < allLi.length) {
      const liToHighlight = allLi[highlightedIndex];
      liToHighlight.classList.add(mainStyles.liActive);
      liToHighlight.scrollIntoView({ block: "nearest" });
    }
  }

  async function fetchAndRenderSuggestions(query) {
    if (!query) {
      suggestionListEl.innerHTML = "";
      return;
    }
    let googleCountryArray = [];

    if (settings.searchCountryCode) {
      googleCountryArray = settings.searchCountryCode.split(',').map(code => code.toLowerCase());
    }

    const request = {
      input: query,
      sessionToken: sessionToken,
      includedRegionCodes: googleCountryArray
    };

    try {
      const { suggestions } =
        await google.maps.places.AutocompleteSuggestion.fetchAutocompleteSuggestions(request);

      suggestionListEl.innerHTML = "";

      highlightedIndex = -1;

      suggestionsData = suggestions;

      suggestions.forEach((suggestion, i) => {
        const li = document.createElement("li");
        li.dataset.index = i;

        const { mainText, secondaryText } = suggestion.placePrediction;
        const highlightedMain = highlightFormattableText(mainText);
        const highlightedSecondary = highlightFormattableText(secondaryText);

        li.innerHTML = `
          <span class="${mainStyles.mainTextLi}">${highlightedMain}</span>
          <span class="${mainStyles.secondaryTextLi}"> ${highlightedSecondary}</span>
        `;

        li.addEventListener("click", () => {
          selectSuggestion(i);
        });

        suggestionListEl.appendChild(li);
      });

    } catch (error) {
      log(error, "fetch google suggestions");
    }
  }

  input.addEventListener("input", async () => {
    const query = input.value.trim();
    if (!query) {
      suggestionListEl.innerHTML = "";
      return;
    }
    fetchAndRenderSuggestions(query);
  });

  input.addEventListener("focus", async () => {
    const query = input.value.trim();
    if (!query) {
      suggestionListEl.innerHTML = "";
      return;
    }
    if (query) {
      fetchAndRenderSuggestions(query);
    }
  });

  document.addEventListener("click", (event) => {
    const clickedInsideInput = input.contains(event.target);
    const clickedInsideList = suggestionListEl.contains(event.target);

    if (!clickedInsideInput && !clickedInsideList) {
      suggestionListEl.innerHTML = "";
    }
  });

  input.addEventListener("keydown", (e) => {
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        if (highlightedIndex < suggestionsData.length - 1) {
          highlightedIndex++;
          highlightCurrentItem();
        }
        break;

      case "ArrowUp":
        e.preventDefault();
        if (highlightedIndex > 0) {
          highlightedIndex--;
          highlightCurrentItem();
        }
        break;

      case "Enter":
        if (highlightedIndex >= 0 && highlightedIndex < suggestionsData.length) {
          e.preventDefault();
          selectSuggestion(highlightedIndex);
        }
        break;

      case "Escape":
        suggestionListEl.innerHTML = "";
        highlightedIndex = -1;
        break;
    }
  });
}
function initGoogleMap() {
  try {
    let zoomControlPosition = google.maps.ControlPosition.RIGHT_BOTTOM;
    if (listPosition == 3) {
      zoomControlPosition = google.maps.ControlPosition.LEFT_BOTTOM;
    }
    let fullscreenControlPosition = google.maps.ControlPosition.RIGHT_TOP;
    if (listPosition == 3) {
      fullscreenControlPosition = google.maps.ControlPosition.LEFT_TOP;
    }
    storeLocatorMap = new google.maps.Map(document.getElementById(mapDivId), {
      center: { lat: parseFloat(settings.centerLat), lng: parseFloat(settings.centerLon) },
      zoom: settings.zoom,
      maxZoom: settings.maxZoom,
      streetViewControl: false,
      mapTypeControl: false,
      zoomControlOptions: {
        position: zoomControlPosition,
      },
      fullscreenControlOptions: {
        position: fullscreenControlPosition,
      },
      gestureHandling: settings.gestureHandling && !window.Progus?.widget ? "cooperative" : "greedy"
    });

    addGoogleResetButton();
    setInitialView();

    let defaultGoogleMapStyles = ["Roadmap", "Satellite", "Hybrid", "Terrain"];

    if (!defaultGoogleMapStyles.includes(settings.provider.split(".")[1]) && settings.googleMapStyleJson) {
      try {
        storeLocatorMap.setOptions({
          styles: JSON.parse(settings.googleMapStyleJson)
        });
      } catch (error) {
        console.log(error);
      }
    } else {
      storeLocatorMap.setOptions({
        mapTypeId: settings.provider.split(".")[1].toLowerCase(),
      });
    }

    if (settings.showTopBar) {
      if (newPlacesApi) {
        // init autocomplete input newPlacesApi
        initPlacesAutocomplete()
      } else {
        // init autocomplete input
        const input = document.getElementById("progus-store-locator-search-input");
        const autocomplete = new google.maps.places.Autocomplete(input);
        // Set country restriction
        if (settings.searchCountryCode) {
          const googleCountryArray = settings.searchCountryCode.split(',').map(code => code.toLowerCase());
          autocomplete.setComponentRestrictions({
            country: googleCountryArray,
          });
        }
        autocomplete.setFields(["address_components", "formatted_address", "geometry"]);
        autocomplete.addListener("place_changed", () => {
          onAutocompleteAddressSelection(autocomplete.getPlace());
        });
      }
    }

    // assign dragend and zoom change event
    google.maps.event.addListener(storeLocatorMap, "idle", onMapMove);

    var map_div = document.getElementById(mapDivId);
    map_div.addEventListener('wheel', updateGestureHandlingStyle);

    // close popup on map click
    google.maps.event.addListener(storeLocatorMap, "click", () => {
      if (googleOpenedPopup) {
        googleOpenedPopup.close();
        googleOpenedPopup = null;
      }
      deactivateHoveredElements();
    });

    // on cluster click event handler
    storeLocatorMap.data.addListener('click', function (event) {
      let coord = event?.feature?.getGeometry()?.get();
      let clusterId = event?.feature?.getProperty("cluster_id");
      if (clusterId && coord) {
        let zoom = settings.disableClusteringAtZoom;
        try {
          zoom = index.getClusterExpansionZoom(event?.feature?.getProperty("cluster_id"));
        } catch (e) {
        }
        setMapView([coord.lat(), coord.lng()], zoom);
      }
    });
  } catch (error) {
    log(error, "init google map");
  }
}

function onMapMove() {
  if (openingPopupAction) {
    openingPopupAction = false;
  } else {
    if (!blockShowingResetBtn) {
      showResetButton();
    }
    blockShowingResetBtn = false;
    updateLocations();
  }
}

function getCooperativeGesturesLocale() {
  let cooperativeGesturesTextLocale = cooperativeGesturesText[getLang()];
  if (!cooperativeGesturesTextLocale) return {};
  return {
    'CooperativeGesturesHandler.WindowsHelpText': cooperativeGesturesTextLocale.scroll,
    'CooperativeGesturesHandler.MacHelpText': cooperativeGesturesTextLocale.scrollMac,
    'CooperativeGesturesHandler.MobileHelpText': cooperativeGesturesTextLocale.touch,
  }
}

function addMaplibreResetButton(position) {
  class MapLibreReset {
    onAdd() {
      resetBtn = document.createElement("div");
      resetBtn.className = "maplibregl-ctrl maplibregl-ctrl-group";
      resetBtn.style.display = "none";
      resetBtn.appendChild(resetMapControl());
      return resetBtn;
    }
  }

  let control = new MapLibreReset();
  storeLocatorMap.addControl(control, position);
}

function addOSMResetButton(position) {
  L.Control.Reset = L.Control.extend({
    onAdd: function () {
      resetBtn = document.createElement("div");
      resetBtn.className = "leaflet-bar leaflet-control leaflet-control-reset";
      resetBtn.style.display = "none";
      resetBtn.appendChild(resetMapControl());
      return resetBtn;
    },
  });
  L.control.reset = function (opts) {
    return new L.Control.Reset(opts);
  }
  L.control.reset({ position }).addTo(storeLocatorMap);
}

function onMapLibreLoad() {
  try {
    storeLocatorMap = new maplibregl.Map({
      container: mapDivId,
      style: mapStylesUrl + settings.provider.split(".")[1].toLowerCase() + ".json",
      center: [settings.centerLon, settings.centerLat],
      zoom: settings.zoom,
      maxZoom: settings.maxZoom,
      minZoom: 1,
      cooperativeGestures: settings.gestureHandling && !window.Progus?.widget,
      locale: getCooperativeGesturesLocale(),
      attributionControl: false
    });
  } catch (e) {
    log(e, 'onMapLibreLoad, set default map provider');
    settings.provider = "OpenStreetMap.Mapnik";
    provider = "OpenStreetMap.Mapnik";
    loadDefaultMap();
    return;
  }

  let fullscreenControlPosition = 'top-right';
  let zoomControlPosition = 'top-right';
  if (listPosition == 3) {
    fullscreenControlPosition = 'top-left';
    zoomControlPosition = 'top-left';
  }

  // add map loader
  class MapLibreLoader {
    onAdd() {
      const ctrl = document.createElement("div");
      ctrl.className = mainStyles.loaderContainer;
      ctrl.appendChild(new L.Control.Loader().onAdd());
      return ctrl;
    }

    _show() {
      document.getElementsByClassName("leaflet-control-loader-container")[0].style.display = "block";
    }

    _hide() {
      document.getElementsByClassName("leaflet-control-loader-container")[0].style.display = "none";
    }
  }
  mapLoader = new MapLibreLoader();
  storeLocatorMap.addControl(mapLoader, "top-left");
  storeLocatorMap.dragRotate.disable();
  storeLocatorMap.touchZoomRotate.disableRotation();
  storeLocatorMap.addControl(new maplibregl.FullscreenControl(), fullscreenControlPosition);
  storeLocatorMap.addControl(new maplibregl.NavigationControl({ showCompass: false }), zoomControlPosition);
  storeLocatorMap.addControl(new maplibregl.AttributionControl({ compact: true }));
  addMaplibreResetButton(zoomControlPosition);
  blockShowingResetBtn = false;

  storeLocatorMap.on('style.load', function () {
    storeLocatorMap.setLayoutProperty('places_country', 'text-field', [
      'get',
      `name:${getLang()}`
    ]);
    storeLocatorMap.setLayoutProperty('physical_point_ocean', 'text-field', [
      'get',
      `name:${getLang()}`
    ]);
    storeLocatorMap.setLayoutProperty('places_locality', 'text-field', [
      'get',
      `name:${getLang()}`
    ]);
    storeLocatorMap.setLayoutProperty('places_region', 'text-field', [
      'get',
      `name:${getLang()}`
    ]);

    setInitialView();
    storeLocatorMap.on('moveend', function () {
      onMapMove();
    });
    // event when click on map
    storeLocatorMap.on('click', function (e) {
      if (e?.originalEvent?.target?.className === "maplibregl-canvas") {
        deactivateHoveredElements();
        if (currentPopup) {
          currentPopup.remove();
          currentPopup = null;
        }
      }
    });
  });
}

function createIndexCluster() {
  let extent = 200;
  if (settings.provider.startsWith("Progus")) {
    extent = 400;
  }
  index = new Supercluster({
    radius: 60,
    minPoints: 1,
    extent
  });
}

function addTopContainer(mainDivNode) {
  let topContainer = document.createElement("div");
  topContainer.className = mainStyles.top;
  if (settings.showTopBar) topContainer.appendChild(getTobBarNode());
  if (tagsPosition == 1) {
    topContainer.appendChild(getTagsField());
  }
  if (tagsPosition == 1 || settings.showTopBar) mainDivNode.appendChild(topContainer);
}

function loadDefaultMap() {
  // create map bounds
  var southWest = L.latLng(-100, -300000),
    northEast = L.latLng(100, 300000);
  var bounds = L.latLngBounds(southWest, northEast);

  let minZoom = 2;
  let maxZoom = settings.maxZoom;
  if (settings.provider.startsWith("Apple")) {
    minZoom = 4;
  }

  if (settings.provider.startsWith("Stamen")) {
    maxZoom = 13;
  }

  // create map
  storeLocatorMap = L.map(mapDivId, {
    center: [settings.centerLat, settings.centerLon],
    zoom: settings.zoom,
    gestureHandling: settings.gestureHandling && !window.Progus?.widget,
    maxBoundsViscosity: 1.0,
    maxBounds: bounds,
    worldCopyJump: true, // when user go outside of horizontal bounds, then duplicate markers - endless world
    minZoom,
    maxZoom,
    tap: false, // it's required to working showing popup when click on marker in Safari
    preferCanvas: true,
    zoomControl: false, // hide default zoom controls
    bounceAtZoomLimits: false, // disable zooming out by fingers more than minZoom
    scrollWheelZoom: false, // disable original zoom function
    smoothWheelZoom: true, // enable smooth zoom
    smoothSensitivity: 1.5, // zoom speed. default is 1,
    zoomSnap: 0.1,
    zoomDelta: 0.5
  });


  // add map loader
  mapLoader = new L.Control.Loader().addTo(storeLocatorMap);

  L.DomEvent.on(storeLocatorMap.getContainer(), "wheel", updateGestureHandlingStyle);

  let controlPos = "topright";
  let attributionControlPos = "bottomright";
  if (listPosition == 3) {
    controlPos = "topleft";
    attributionControlPos = "bottomleft";
  }

  // add zoom control
  L.control.zoom({
    position: controlPos,
  }).addTo(storeLocatorMap);

  // add fullscreen control
  new L.Control.Fullscreen({
    position: controlPos,
  }).addTo(storeLocatorMap);

  // set map provider
  if (!settings.provider.startsWith("Apple")) {
    if (settings.provider.startsWith("MapBox")) {
      if (mapboxToken != "") {
        L.tileLayer.provider(settings.provider, {
          accessToken: mapboxToken,
          id: "mapbox/" + settings.provider.split(".")[1]
        }).addTo(storeLocatorMap);
      } else {
        L.tileLayer.provider("OpenStreetMap.Mapnik").addTo(storeLocatorMap);
      }
    } else {
      L.tileLayer.provider(settings.provider).addTo(storeLocatorMap);
    }
  }

  // add contribution info
  new L.Control.AttributionInfo({ position: attributionControlPos }).addTo(storeLocatorMap);

  // add reset control
  addOSMResetButton(controlPos);
  blockShowingResetBtn = false;

  clusters = L.geoJson(null, {
    pointToLayer: createClusterIcon
  }).addTo(storeLocatorMap);

  clusters.on('click', (e) => {
    if (e?.layer?.feature?.properties?.cluster_id && e?.layer?.feature?.geometry?.coordinates) {
      let coord = e.layer.feature.geometry.coordinates;
      let target = L.latLng(coord[1], coord[0]);
      try {
        let zoom = 10;
        if (e.layer?.feature?.properties?.cluster_id) {
          zoom = index.getClusterExpansionZoom(e.layer.feature.properties.cluster_id);
        }
        storeLocatorMap.setView(target, zoom);
      } catch (e) {
        storeLocatorMap.setView(target, settings.disableClusteringAtZoom);
      }
    }
  });

  storeLocatorMap.on("moveend", () => {
    onMapMove();
  });

  // on map move change
  setInitialView();
}

function applyMapProvider() {
  try {
    switch (provider) {
      case "Google":
        if (settings.googleToken) {
          const loader = new Loader({
            apiKey: settings.googleToken,
            version: "weekly",
            libraries: ["places", "geometry"]
          });

          loader.load().then(async () => {
            initGoogleMap();
          })
            .catch(err => {
              log(err, "google map loader error", {
                token: settings.googleToken ? "provided" : "missing"
              });
            })
        }
        break;
      case "Progus":
        // injectJs("https://unpkg.com/maplibre-gl@4.0.1/dist/maplibre-gl.js", () => {
        onMapLibreLoad();
        // });
        break;
      default:
        loadDefaultMap();
        if (appleToken != "" && provider === "Apple") {
          injectJs("https://cdn.apple-mapkit.com/mk/5.7.0/mapkit.js", () => {
            onMapkitLoad();
          }, (error) => {
            log(error, "apple mapkit.js not loaded");
          });
        }
        break;
    }

    if (provider !== "Google") {
      initAutocompleteSl();
    }
  } catch (error) {
    log(error, "apply map provider error", {
      provider: provider,
      appleToken: appleToken,
      settings: settings,
      error: error
    });
  }
}

function create() {
  let mainDivNode = document.getElementById(mainDivId);
  addTopContainer(mainDivNode);

  if (settings.showStoresList && listPosition == 1) {
    mainDivNode.appendChild(getMenu(true));
  }
  mainDivNode.appendChild(getContentContainerNode());
  if (settings.showStoresList && listPosition == 2) {
    mainDivNode.appendChild(getMenu(true));
  }
  tagsSelector = multipleSelect('.multiple-select', {
    hideOptgroupCheckboxes: true,
    placeholder: storeLocatorText.filters,
    minimumCountSelected: 0,
    selectAll: false,
    countSelectedText: `# ${storeLocatorText.filters_selected}`,
    allSelectedText: `${tags.length} ${storeLocatorText.filters_selected}`,
    onClick: (tag) => {
      window.onProgusStoreLocatorTagClick({ checked: tag.selected, value: tag.value });
    }
  });
  handleDefaultOpenLocationsList();
  createIndexCluster();
  applyMapProvider();
  updateTopBarListeners();
  if (settings.mapBehaviour == 1) {
    updateLocations();
  }
}

function createClusterIcon(feature, latlng) {
  if (!feature?.properties?.cluster) return L.marker(latlng);

  const count = feature.properties.point_count;
  const size =
    count < 100 ? 'small' :
      count < 1000 ? 'medium' : 'large';
  const icon = L.divIcon({
    html: `<div><span>${feature.properties.point_count_abbreviated}</span></div>`,
    className: `marker-cluster marker-cluster-${size}`,
    iconSize: L.point(40, 40)
  });

  return L.marker(latlng, { icon });
}

function deactivateHoveredElements() {
  const allElements = document.getElementsByClassName(mainStyles.storeListElement);
  if (allElements?.length) {
    for (var i = 0; i < allElements.length; i++) {
      allElements[i].classList.remove(mainStyles.storeListElementActive);
    }
  }
}

function onPopupClose() {
  openingPopupAction = false;
  currentOpenedStoreId = 0;
  deactivateHoveredElements();
}

// get store image on marker click
function onPopupOpen(popupEvent) {
  openingPopupAction = true;
  currentOpenedStoreId = popupEvent.target.options.id;
  markerToOpen = getMarkerByStoreId(currentOpenedStoreId);
  activateLocationsListElement(currentOpenedStoreId);
}

function getMarkerIcon(markerStyle) {
  if (markerStyle.customMarkerUrl) {
    // custom marker image
    return L.ExtraMarkers.icon({
      innerHTML: `<div class="custom-icon" style='background: url(${getImageUrl(markerStyle.customMarkerUrl)})' />`,
      svg: true,
      shadowSize: [0, 0],
    });
  } else {
    var imageUrl = null;
    if (markerStyle.customIconUrl) {
      // custom marker icon
      imageUrl = getImageUrl(markerStyle.customIconUrl);
    }
    return L.ExtraMarkers.icon({
      icon: "sl-ic-1-" + markerStyle.icon,
      customMarkerIcon: imageUrl,
      markerColor: markerStyle.background,
      iconColor: markerStyle.iconColor,
      shape: getMarkerShapeName(markerStyle.shape),
      shadowSize: [0, 0],
      svg: true,
    });
  }
}

function addLeafletMarkers() {
  // clear all markers
  if (markersGroup) markersGroup.clearLayers();
  if (clusters) clusters.clearLayers();

  // create markers group
  markersGroup = L.featureGroup();
  if (settings.clusteringMarkers && storeLocatorMap.getZoom() < settings.disableClusteringAtZoom) {
    clusters.addData(getFeatureCollection());
  } else {
    markersGroup = L.featureGroup();
    var markerIcon = null;
    // marker design
    if (settings.markerStyles) {
      if (settings.markerStyles.length > 0) {
        markerIcon = getMarkerIcon(defaultMarkerStyle);
      } else {
        markerIcon = L.ExtraMarkers.icon({
          icon: "sl-ic-1-" + settings.markerIcon,
          markerColor: getMarkerColor(),
          iconColor: settings.markerIconColor,
          shape: getMarkerShapeName(settings.markerShape),
          shadowSize: [0, 0],
          svg: true
        });
      }
    } else {
      // old marker icon style
      markerIcon = L.ExtraMarkers.icon({
        icon: "sl-ic-1-" + settings.markerIcon,
        markerColor: getMarkerColor(),
        iconColor: settings.markerIconColor,
        shape: getMarkerShapeName(settings.markerShape),
        shadowSize: [0, 0],
        svg: true
      });
    }
    // create marker of every currently visible store, bind popup and actions for it, then add it to markersGroup
    for (let store of currentLocations) {
      var icon = markerIcon;
      // if store has custom marker assigned
      if (store.markerId) {
        var customMarkerStyle = settings.markerStyles.find(ms => ms.id == store.markerId);
        if (customMarkerStyle) icon = getMarkerIcon(customMarkerStyle);
      }
      const marker = L.marker([store.lat, store.lon], {
        icon,
        id: store.id,
      }).on("click", () => {
        openingPopupAction = true;
      });

      marker.bindPopup(getMarkerPopup(store), {
        autoPanPaddingTopLeft: L.point(50, 50),
        autoPanPaddingBottomRight: L.point(50, 50),
      }).on("popupopen", onPopupOpen).on("popupclose", onPopupClose);

      markersGroup.addLayer(marker);
      storeLocatorMap.addLayer(markersGroup);
    }
    if (currentOpenedStoreId) {
      markerToOpen = getMarkerByStoreId(currentOpenedStoreId);
      bindPopupAndOpenMarker(markerToOpen);
      // if (markerToOpen) markerToOpen.openPopup();
      currentOpenedStoreId = 0;
    }
  }
}

function getGoogleMarkerLabel(markerStyle) {
  if (markerStyle.customMarkerUrl) { return "" }
  var className = "";
  var color = "";
  // custom marker icon
  if (markerStyle.customIconUrl) {
    className = `${mainStyles.customGoogleMarkerImg} google-marker-${markerStyle.id}`;
    injectCss(`.google-marker-${markerStyle.id} {background-image: url('${getImageUrl(markerStyle.customIconUrl)}')}`);
  } else {
    className = "sl-ic-1-" + markerStyle.icon;
    color = markerStyle.iconColor;
  }
  return {
    text: " ",
    className,
    color,
  };
}

function getGoogleMarker(store) {
  let icon = null;
  var label = "";
  var markerStyle = null;

  // if store has custom marker assigned
  if (store.markerId) {
    markerStyle = settings.markerStyles.find(ms => ms.id == store.markerId);
  }

  if (markerStyle) {
    icon = getGoogleMarkerIcon(markerStyle);
    label = getGoogleMarkerLabel(markerStyle);
  } else {
    if (defaultMarkerStyle) {
      icon = getGoogleMarkerIcon(defaultMarkerStyle);
      label = getGoogleMarkerLabel(defaultMarkerStyle);
    } else {
      // old marker style
      icon = getGoogleMarkerIcon({
        shape: settings.markerShape,
        background: getMarkerColor()
      });
      label = getGoogleMarkerLabel({
        iconColor: settings.markerIconColor,
        icon: settings.markerIcon
      });
    }
  }

  let markerOpts = {
    position: { lat: parseFloat(store.lat), lng: parseFloat(store.lon) },
    map: storeLocatorMap,
    icon,
    label
  };

  let marker = new google.maps.Marker(markerOpts);
  marker.storeId = store.id;

  return marker;
}

function getMapLibreMarker(store) {
  var markerStyle = defaultMarkerStyle;
  let markerIcon = null;
  let imgRatio = 1;

  // if location has custom marker assigned
  if (store.markerId) {
    markerStyle = settings.markerStyles.find(ms => ms.id == store.markerId);
  }

  if (markerStyle) {
    if (markerStyle.imgRatio) imgRatio = markerStyle.imgRatio;
    markerIcon = getMarkerIcon(markerStyle);
  } else {
    markerIcon = L.ExtraMarkers.icon({
      icon: "sl-ic-1-" + settings.markerIcon,
      markerColor: getMarkerColor(),
      iconColor: settings.markerIconColor,
      shape: getMarkerShapeName(settings.markerShape),
      shadowSize: [0, 0],
      svg: true
    });
  }

  let size = 35;

  let result = markerIcon.createIcon();
  result.style.marginLeft = 'unset';
  result.style.marginTop = '-20px';
  if (markerStyle?.customMarkerUrl) {
    result.style.height = size + 'px';
    result.style.width = parseInt(size * imgRatio) + 'px';
  }
  result.style.paddingTop = '0';
  result.dataset.id = store.id;
  result.addEventListener("click", () => {
    activateLocationsListElement(store.id);
  });
  return result;
}

let currentPopup = null;

function openMaplibrePopup(store) {
  // Close existing popups if any
  if (currentPopup) {
    currentPopup.remove();
    currentPopup = null;
  }

  // create and open a new popup
  currentPopup = new maplibregl.Popup({
    closeOnClick: false,
    focusAfterOpen: false,
    offset: {
      'top': [0, 0],
      'bottom': [0, -25],
      'left': [0, -25],
      'bottom-left': [0, -25],
      'right': [0, -25],
      'bottom-right': [0, -25],
    }
  }).setLngLat([store.lon, store.lat])
    .setHTML(getMarkerPopup(store))
    .addTo(storeLocatorMap);
}

function addMapLibreMarkers() {
  if (mapLibreMarkers.length) {
    for (let marker of mapLibreMarkers) {
      marker.remove();
    }
    mapLibreMarkers = [];
  }

  if (settings.clusteringMarkers && storeLocatorMap.getZoom() < settings.disableClusteringAtZoom) {
    if (!storeLocatorMap.getSource('clusters')) {
      storeLocatorMap.addSource("clusters", {
        type: "geojson",
        data: getFeatureCollection(),
      });
      storeLocatorMap.addLayer({
        id: "clusters-circle",
        type: "circle",
        source: "clusters",
        paint: {
          "circle-color": settings.groupingLocationsColor,
          "circle-radius": 16,
          "circle-opacity": 0.85,
          "circle-stroke-color": settings.groupingLocationsColor,
          "circle-stroke-opacity": 0.5,
          "circle-stroke-width": 4,
        }
      });
      storeLocatorMap.addLayer({
        id: "clusters-label",
        type: "symbol",
        source: "clusters",
        layout: {
          "text-font": ["RobotoRegular"],
          "text-size": 14,
          "text-field": ["get", "point_count_abbreviated"],
          "text-offset": [0, 0.1]
        },
        paint: {
          "text-color": groupingLocationsTextColor
        }
      });
      // Change the cursor to a pointer when the mouse is over the places layer.
      storeLocatorMap.on('mouseenter', 'clusters-circle', function () {
        storeLocatorMap.getCanvas().style.cursor = 'pointer';
      });

      // Change it back to a pointer when it leaves.
      storeLocatorMap.on('mouseleave', 'clusters-circle', function () {
        storeLocatorMap.getCanvas().style.cursor = '';
      });

      // on cluster click
      storeLocatorMap.on('click', 'clusters-circle', function (e) {
        var coordinates = e.features[0].geometry.coordinates.slice();
        let clusterId = e.features[0].id;
        if (clusterId && coordinates) {
          let zoom = settings.disableClusteringAtZoom;
          try {
            zoom = index.getClusterExpansionZoom(clusterId);
          } catch (e) {
          }
          setMapView([coordinates[1], coordinates[0]], zoom);
        }
      });
    } else {
      storeLocatorMap.getSource('clusters').setData(getFeatureCollection());
    }
  } else {
    // remove clusters
    if (storeLocatorMap.getSource('clusters')) {
      storeLocatorMap.removeLayer("clusters-circle");
      storeLocatorMap.removeLayer("clusters-label");
      storeLocatorMap.removeSource("clusters");
    }

    // array of markers - useful when deleting markers
    let tempMarkers = [];

    for (let store of currentLocations) {
      // create marker and add it to map
      let marker = new maplibregl.Marker({ element: getMapLibreMarker(store) })
        .setLngLat([parseFloat(store.lon), parseFloat(store.lat)])
        .addTo(storeLocatorMap);

      // Add click event listener to each marker
      marker.getElement().addEventListener('click', () => {
        openMaplibrePopup(store);
      });

      // add marker to array to be able to delete it later
      tempMarkers.push(marker);
    }
    mapLibreMarkers = tempMarkers;

    if (currentOpenedStoreId) {
      openMaplibrePopup(locations.find(el => el.id == currentOpenedStoreId));
      currentOpenedStoreId = 0;
    }
  }

}

function getFeaturePoint(lon, lat) {
  return {
    "type": "Feature",
    "geometry": {
      "type": "Point",
      "coordinates": [lon, lat]
    }
  };
}

function getFeatureCollection() {
  index.load(currentLocations.map(point => getFeaturePoint(point.lon, point.lat)));
  let result = index.getClusters([-180, -90, 180, 90], storeLocatorMap.getZoom().toFixed(0));
  return {
    "type": "FeatureCollection",
    "features": result
  }
}

function addGoogleMarkers() {
  // clear markers and clusters data
  storeLocatorMap.data.forEach(feature => {
    storeLocatorMap.data.remove(feature);
  });
  if (googleMarkers) {
    googleMarkers.forEach((marker) => {
      marker.setMap(null);
    });
  }

  if (settings.clusteringMarkers && storeLocatorMap.getZoom() < settings.disableClusteringAtZoom) {
    let featureCollection = getFeatureCollection();
    const svg = window.btoa(`
            <svg fill="${settings.groupingLocationsColor}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240">
            <circle cx="120" cy="120" opacity=".8" r="90" />
            <circle cx="120" cy="120" opacity=".5" r="110" />
            </svg>`);
    storeLocatorMap.data.addGeoJson(featureCollection);
    storeLocatorMap.data.setStyle((feature) => {
      return {
        label: {
          text: feature.getProperty("point_count_abbreviated"),
          color: groupingLocationsTextColor
        },
        icon: {
          url: `data:image/svg+xml;base64,${svg}`,
          scaledSize: new google.maps.Size(45, 45),
        },
        className: "testtests"
      };
    });
  } else {
    googleMarkers = currentLocations.map((store) => {
      const marker = getGoogleMarker(store);
      marker.addListener("click", () => {
        openGooglePopup(marker, store);
      });
      return marker;
    });
  }
  openGooglePopupByStoreId(currentOpenedStoreId);
  currentOpenedStoreId = 0;
}

function openGooglePopupByStoreId(id) {
  if (id) {
    let foundStore = currentLocations.find(el => el.id == id);
    if (foundStore) {
      let tempMarker = getGoogleMarker(foundStore);
      tempMarker.addListener("click", () => {
        openGooglePopup(tempMarker, foundStore);
      });
      googleMarkers.push(tempMarker);
      openGooglePopup(tempMarker, foundStore);
    }
  }
}

function activateLocationsListElement(storeId) {
  const storesListContainer = document.getElementById(mainStyles.storeListElements);
  if (storesListContainer) {
    deactivateHoveredElements();
    const element = document.querySelectorAll(`.${mainStyles.storeListElement}[data-id="${storeId}"]`)[0];
    if (element) {
      storesListContainer.scrollTo({ top: element.offsetTop - 100, behavior: 'smooth' });
      element.classList.add(mainStyles.storeListElementActive);
    }
  }
}

let currentMarkerZIndex = 0;
function openGooglePopup(marker, store) {
  currentMarkerZIndex++;
  marker.setZIndex(google.maps.Marker.MAX_ZINDEX + currentMarkerZIndex);
  if (googleOpenedPopup) {
    googleOpenedPopup.close();
    googleOpenedPopup = null;
  }
  googleOpenedPopup = new google.maps.InfoWindow({
    content: getMarkerPopup(store),
  });
  googleOpenedPopup.open({
    anchor: marker,
    storeLocatorMap,
  });
  openingPopupAction = true;
  activateLocationsListElement(store.id);
}

function showMarkers() {
  if (storeLocatorMap) {
    switch (settings.provider.split(".")[0]) {
      case "Google":
        addGoogleMarkers();
        break;
      case "Progus":
        addMapLibreMarkers();
        break;
      default:
        addLeafletMarkers();
    }
  }
}

function findLocationsBounds() {
  if (locations.length) {
    let [minLat, maxLat, minLon, maxLon] = [Number(locations[0].lat), Number(locations[0].lat), Number(locations[0].lon), Number(locations[0].lon)];

    locations.forEach(({ lat, lon }) => {
      lat = Number(lat);
      lon = Number(lon);
      if (lat < minLat) minLat = lat;
      if (lat > maxLat) maxLat = lat;
      if (lon < minLon) minLon = lon;
      if (lon > maxLon) maxLon = lon;
    });

    return { minLat, maxLat, minLon, maxLon };
  } else {
    return null;
  }
}


function setViewToStartBounds() {
  if (startBounds) {
    if (typeof startBounds.minLat !== "undefined" && startBounds?.minLat) {
      var ne = [startBounds.maxLat, startBounds.maxLon];
      var sw = [startBounds.minLat, startBounds.minLon];
      if (ne[0] == sw[0] && ne[1] == sw[1]) {
        setMapView([ne[0], ne[1]], 12);
      } else {
        fitBounds([ne, sw], 0.1);
      }
    }
  }
}

function resetView() {
  switch (settings.mapState) {
    case 3:
      setMapView(
        [settings.centerLat, settings.centerLon],
        settings.zoom
      );
      break;
    default:
      setViewToStartBounds();
      break;
  }
}

async function setInitialView() {
  await fetchAllLocations();
  switch (settings.mapState) {
    case 1:
      setViewToStartBounds();
      break;
  }

  // mapState = 2 only for some of old users
  if (settings.mapState == 2 || settings.initialGeolocation) {
    findMyLocationBtnClick();
  }
}

function getMarkerShapeName(shape) {
  switch (shape) {
    case 1:
      return "circle";
    case 2:
      return "square";
    case 3:
      return "penta";
    case 4:
      return "star";
  }
}

function getMarkerColor() {
  switch (settings.markerColor) {
    case 1:
      return "red";
    case 2:
      return "orange-dark";
    case 3:
      return "orange";
    case 4:
      return "yellow";
    case 5:
      return "blue-dark";
    case 6:
      return "cyan";
    case 7:
      return "purple";
    case 8:
      return "violet";
    case 9:
      return "pink";
    case 10:
      return "green-dark";
    case 11:
      return "green";
    case 12:
      return "green-light";
    case 13:
      return "black";
    case 14:
      return "white";
    case 15:
      return "blue";
  }
}

function getAlignText(align) {
  switch (align) {
    case "1":
      return "start";
    case "2":
      return "center";
    case "3":
      return "end";
  }
}

function getMarkerPopup(store) {
  let result = "";
  if (settings?.popupOrder?.length > 0) {
    settings.popupOrder.forEach(el => {
      result += getPopupContentElementHtml(el, store);
    });
    return result;
  }
}

function getFieldIcon(id) {
  switch (id) {
    case 3: return "map-marker";
    case 4: return "clock-o";
    case 5: return "info-circle";
    case 6: return "phone";
    case 7: return "envelope";
    case 8: return "fax";
    default: return null;
  }
}

function getPopupContentElementHtml(el, store, isListElement = false) {
  let padding = isListElement ? "2px 8px" : null;
  if (!el.b && !el.r) padding = "0";
  // if id is bigger than 30, it is custom field
  if (el.id > 30) {
    if (!store.customFields || !settings.customFields) return "";
    let customFields = JSON.parse(store.customFields);
    let field = customFields.find(cf => cf ? (cf.id == el.id) : false);
    let fieldName = settings.customFields.find(cf => cf.id == el.id)?.name;
    let fieldType = settings.customFields.find(cf => cf.id == el.id)?.type;
    if (!fieldName || !fieldType) return "";
    // return if no field value
    if (!field?.value) return "";
    // translate field name if translation exists
    if (storeLocatorText["customFields_" + el.id]) fieldName = storeLocatorText["customFields_" + el.id];
    let classValue = "";
    if (field.value) {
      classValue = field.value.replace(/\s/g, '').toLowerCase();
    }
    switch (fieldType) {
      case 1:
        return popupElement([field.value], el.b, "", el.c, el.a, el.r, padding, "custom-" + classValue);
      case 2:
        return popupBtn(field.value, fieldName, "default1", "", el.c, el.b, el.a, el.r, null, "custom-" + classValue);
      default:
        return "";
    }
  }

  let icon = isListElement ? null : getFieldIcon(el.id);

  switch (el.id) {
    case 1:
      padding = isListElement ? "0 8px" : "0 13px";
      return `<h2 class="${mainStyles.popupName}"'>${popupElement([store.name], el.b, icon, el.c, el.a, el.r, padding, "name")}</h2>`;
    case 2:
      if (store.imageUrl) {
        var imageUrl = getImageUrl(store.imageUrl);
        return `<img class='${mainStyles.popupImg}' src='${imageUrl}' />`;
      }
      return "";
    case 3:
      return popupElement([store.address, getAddressFormatted(store), store.country], el.b, icon, el.c, el.a, el.r, padding, "address");
    case 4:
      if (!store.openingHours) return "";
      return popupElement([store.openingHours.replaceAll("\n", "<br>")], el.b, icon, el.c, el.a, el.r, padding, "opening-hours");
    case 5:
      if (!store.info) return "";
      return popupElement([store.info.replaceAll("\n", "<br>")], el.b, icon, el.c, el.a, el.r, padding, "info");
    case 6:
      return popupBtn("tel:" + store.phone, store.phone, "default1", icon, el.c, el.b, el.a, el.r, padding, "tel");
    case 7:
      return popupBtn("mailto:" + store.email, store.email, "default1", icon, el.c, el.b, el.a, el.r, padding, "mail");
    case 8:
      return popupBtn("fax:" + store.fax, store.fax, "default1", icon, el.c, el.b, el.a, el.r, padding, "fax");
    case 9:
      return popupBtn(getDirectionsUrl(store), storeLocatorText.get_directions, "default1", icon, el.c, el.b, el.a, el.r, padding, "directions");
    case 10:
      return popupBtn(store.website, storeLocatorText.open_website, "default1", icon, el.c, el.b, el.a, el.r, padding, "website");
    case 11:
      let style = "";
      if (el.a) {
        style = `text-align:${el.a}`;
      }
      return `<div class='progus-store-locator-media-container' style=${style}>` + popupMediaBtn(store.facebook, "facebook1", el.c) +
        popupMediaBtn(store.linkedin, "linkedin1", el.c) +
        popupMediaBtn(store.twitter, "twitter1", el.c) +
        popupMediaBtn(store.google, "google1", el.c) +
        popupMediaBtn(store.instagram, "instagram1", el.c) + "</div>";
    case 12:
      return popupTags(store.tags, el);
    default:
      return "";
  }
}

function popupTags(storeTags, el) {
  let result = "";
  if (storeTags) {
    if (storeTags.length > 0) {
      let style = "";
      if (el.a) {
        style = `text-align:${el.a}`;
      }
      result = `<div class='${mainStyles.popupTagsContainer}' style="${style}">`;
      try {
        for (let tagId of JSON.parse(storeTags)) {
          let foundTag = tags.find((t) => t.id == tagId);
          result += getTagHtml(foundTag, el.c, el.b, el.r, false);
        }
      } catch (e) {
        console.log(e);
      }
      result += "</div>";
    }
  }
  return result;
}

function popupElement(content, bgColor, icon, textColor = null, align = null, borderColor = null, padding = null, classValue = "") {
  if (!textColor) textColor = "#000";
  if (
    content.find(
      (o) =>
        o !== null &&
        o !== "" &&
        o.replaceAll("<br>", "").replaceAll(/\s/g, "") !== ""
    )
  ) {
    let style = "";
    if (bgColor) {
      style += `background-color:${bgColor};`;
    }
    if (textColor) {
      style += `color:${textColor};`;
    }
    if (borderColor) {
      style += `border:1px solid ${borderColor};`;
    }
    if (padding) {
      style += `padding:${padding};`;
    }
    let html = `<div class='${mainStyles.popupElement} progus-store-locator-el-${classValue}' style='${style}'>`;
    html += `<div class='${mainStyles.verticalAlign}' style='${align ? `justify-content: ${align};` : ""}'>`;
    if (icon) {
      html += `<span class='${mainStyles.popupElementIcon} sl-ic-1-${icon}'></span>`;
    }
    html += `<div class='progus-store-locator-popup-element-content' style='${align ? `text-align: ${align};` : ""}'>`;
    for (let c of content) {
      if (c && c !== "" && c.replaceAll(/\s/g, "") !== "" && c != "null") {
        html += c + "<br>";
      }
    }
    html += "</div></div></div>";
    return html;
  }
  return "";
}

function popupMediaBtn(url, icon, color = null) {
  if (url && icon) {
    if (!url.startsWith("https://") && !url.startsWith("http://")) {
      url = "https://" + url;
    }
    let style = "";
    if (color) {
      style = `color:${color};`;
    }
    return (
      `<a class="clickable ${mainStyles.popupMediaBtn}" href='${url}' target='_blank'>` +
      `<span style="${style}" class='${mainStyles.mediaBtn} sl-ic-1-` +
      icon +
      "'></span></a>"
    );
  }
  return "";
}

function popupBtn(url, value, btnClass, icon, textColor = null, bgColor = null, align = null, borderColor = null, padding = null, classValue = "") {
  if (url && value) {
    if (!url.startsWith("https://") && !url.startsWith("http://") && !url.startsWith("tel:") && !url.startsWith("mailto:") && !url.startsWith("fax:")) {
      url = "https://" + url;
    }

    let result = `<a class='clickable' href='${url}' target='_blank'>`;
    if (textColor || bgColor) {
      result += popupElement([value], bgColor, icon, textColor, align, borderColor, padding, classValue);
    } else {
      result += `<button class='${btnClass} ${classValue}'>`;
      if (icon) result += `<span class='sl-ic-1-${icon}'></span>&nbsp;`;
      result += `<div class=${mainStyles.ellipseBtnText}>${value}</div></button>`;
    }
    result += `</a>`;
    return result;
  }
  return "";
}

function hideMap() {
  const mapEl = document.getElementById(mainDivId);
  if (mapEl) mapEl.style.display = "none";
}

function getOneLineAddress(address, city, province, zipCode, country) {
  let el = [address, city, province + " " + zipCode, country].filter(
    (n) => n
  );
  el = el.map((s) => s.trim());
  el = el.filter((s) => s != "");
  return el.join(", ");
}

function sendSearchEvent(foundPlace, hasAddress = false, geolocation = 0) {
  // create data object with closest location patttern and geolocation value
  let data = {
    location: {
      name: "",
      address: "",
    },
    geolocation
  };

  // add closest location
  if (currentLocations[0]) {
    data.location.name = currentLocations[0].name;
    data.location.address = getOneLineAddress(currentLocations[0].address, currentLocations[0].city, currentLocations[0].province, currentLocations[0].zipCode, currentLocations[0].country);
  }

  if (!hasAddress) {
    data.foundPlace = {
      id: foundPlace.id,
      text: foundPlace.text,
      text_en: foundPlace.text_en,
      center: foundPlace.center,
      context: foundPlace.context
    }
  } else {
    data.foundPlace = foundPlace;
  }

  fetch(`${API_URL}e?shop=${shop}`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  }).catch(error => {
    log(error, "send search event");
  });
}

async function autocompleteQuery(value, lang = "en") {
  let url = `https://api.locationiq.com/v1/autocomplete?normalizecity=1&limit=20&accept-language=${lang}&dedupe=1&key=pk.7bf3eda08a8b6b31a20fdfecc51b8e66&q=${value}`;
  if (settings.searchCountryCode) {
    const locationIqCodes = settings.searchCountryCode.toLowerCase()
    url += "&countrycodes=" + locationIqCodes
  }
  return fetch(url)
    .then(response => response.json())
    .then(response => response)
    .catch(error => {
      log(error, "locationiq autocomplete error");
      return [];
    });
}

async function lokupForOSMElement(value) {
  let url = `https://api.locationiq.com/v1/lookup?addressdetails=1&namedetails=0&normalizeaddress=1&normalizecity=1&accept-language=en&key=pk.7bf3eda08a8b6b31a20fdfecc51b8e66&osm_ids=${value}`;
  return fetch(url)
    .then(response => response.json())
    .then(response => response)
    .catch(error => {
      log(error, "locationiq lookup error");
    });
}

// The autoComplete.js Engine instance creator
function initAutocompleteSl() {
  if (settings.showTopBar) {
    const autoCompleteJS = new autoComplete({
      selector: () => {
        return document.getElementById("progus-store-locator-search-input");
      },
      data: {
        src: async (query) => {
          var searchIcon = document.getElementsByClassName(mainStyles.formIconsSearch)[0];
          if (searchIcon) searchIcon.className = mainStyles.formIconsSpinner;
          try {
            // Fetch External Data Source
            let lang = getLang();
            let data = await autocompleteQuery(query, lang);
            if (data?.length) data = sortAutocompleteResults(query, data);
            if (data?.length) return data;
            return [];
          } catch (error) {
            log(error, "autocomplete.js error");
            searchIcon = document.getElementsByClassName(mainStyles.formIconsSpinner)[0];
            if (searchIcon) searchIcon.className = mainStyles.formIconsSearch;
            return [];
          }
        },
        keys: ["display_name"],
      },
      cache: true,
      threshold: 2, // start search query when are 2 letters
      searchEngine: "none", // custom parameter written by me, it's required to avoid hiding results that are not matching with input value. e.g.: I search for "Polskaa", first result is "Polska" but is not showing without this parameter
      debounce: 200, // wait x ms before start search query
      placeHolder: storeLocatorText.searchbar_placeholder,
      submit: true,
      events: {
        input: {
          keydown(event) {
            // Enter clicked
            if (event.keyCode == 13) {
              // If cursor moved
              if (autoCompleteJS.isOpen) {
                onAutocompleteAddressSelection(autoCompleteJS.feedback?.matches[0]?.value);
                autoCompleteJS.close();
              }
            }
          }
        }
      },
      resultItem: {
        element: (item, data) => {
          if (data?.value && item) {
            item.innerHTML = extractAddressString(data.value, true);
          }
        },
      },
    });

    document
      .getElementById("progus-store-locator-search-input")
      .addEventListener("selection", function (event) {
        onAutocompleteAddressSelection(event.detail.selection.value);
        hideKeyboard(document.getElementById("progus-store-locator-search-input"));
      });

    document
      .getElementById("progus-store-locator-search-input")
      .addEventListener("results", function (event) {
        var searchIcon = document.getElementsByClassName(mainStyles.formIconsSpinner)[0];
        if (searchIcon) searchIcon.className = mainStyles.formIconsSearch;
      });
  }

  let zoomIn = document.getElementsByClassName("leaflet-control-zoom-in")[0];
  let zoomOut = document.getElementsByClassName("leaflet-control-zoom-out")[0];

  if (zoomIn && zoomOut) {
    let increaseValue = 0.5;
    let decreaseValue = -0.5;

    holdit(
      zoomIn,
      function () {
        if (settings.provider.includes("Apple")) {
          storeLocatorMap.zoomIn(0.5);
        } else {
          smoothZoom(increaseValue);
        }
      },
      40,
      100
    );

    zoomIn.addEventListener("click", function (e) {
      e.preventDefault();
      if (settings.provider.includes("Apple")) {
        storeLocatorMap.zoomIn(0.5);
      } else {
        smoothZoom(increaseValue);
      }
    });

    holdit(
      zoomOut,
      function () {
        if (settings.provider.includes("Apple")) {
          storeLocatorMap.zoomOut(0.5);
        } else {
          smoothZoom(decreaseValue);
        }
      },
      40,
      100
    );

    zoomOut.addEventListener("click", function (e) {
      e.preventDefault();
      if (settings.provider.includes("Apple")) {
        storeLocatorMap.zoomOut(0.5);
      } else {
        smoothZoom(decreaseValue);
      }
    });
  }
}

function smoothZoom(value) {
  let goalZoom = storeLocatorMap.getZoom() + value;
  if (goalZoom < storeLocatorMap.getMinZoom() || goalZoom > storeLocatorMap.getMaxZoom()) {
    goalZoom = storeLocatorMap._limitZoom(goalZoom);
  }
  storeLocatorMap.flyTo(getMapCenter(), goalZoom, { duration: 0.2 });
}

function getGoogleAddressField(components, field, useLongText = false) {
  if (!components?.length) return "";
  let el = components.find(component =>
    component.types.includes(field)
  );
  const propName = useLongText ? "longText" : "long_name";
  if (el?.[propName]) return el[propName];
  return "";
}

function hideKeyboard(element) {
  element.setAttribute('readonly', 'readonly'); // Force keyboard to hide on input field.
  element.setAttribute('disabled', 'true'); // Force keyboard to hide on textarea field.
  setTimeout(function () {
    element.blur();  //actually close the keyboard
    element.removeAttribute('readonly');
    element.removeAttribute('disabled');
  }, 100);
}

async function onAutocompleteAddressSelection(foundPlace) {
  // const foundPlaceObj = {
  //   address_components: place.addressComponents, long_name, short_name, types
  //   formatted_address: place.formattedAddress, string
  //   geometry: {
  //     location: place.location, lat, lng
  //     viewport: place.viewport
  //   }
  // };
  try {
    if (foundPlace) {
      let name = "";
      let center = null;
      let ne = null, sw = null;
      let hasAddress = false;
      let bounds = null;
      if (provider === "Google") {
        let coord = foundPlace.geometry?.location;
        if (coord) center = [coord.lat(), coord.lng()];
        name = foundPlace.formatted_address;
        hasAddress = true;
        let allAddress = {
          country: getGoogleAddressField(foundPlace.address_components, "country", Boolean(newPlacesApi)),
          city: getGoogleAddressField(foundPlace.address_components, "locality", Boolean(newPlacesApi)),
          province: getGoogleAddressField(foundPlace.address_components, "administrative_area_level_1", Boolean(newPlacesApi)),
          zipCode: getGoogleAddressField(foundPlace.address_components, "postal_code", Boolean(newPlacesApi))
        }
        let viewport = foundPlace.geometry?.viewport;
        if (viewport) {
          ne = [viewport.getNorthEast().lat(), viewport.getNorthEast().lng()];
          sw = [viewport.getSouthWest().lat(), viewport.getSouthWest().lng()];
          bounds = [ne, sw];
        }
        if (center?.length === 2) {
          foundPlace.center = [center[1], center[0]];
        }
        foundPlace.allAddress = allAddress;
      } else {
        hasAddress = true;
        name = extractAddressString(foundPlace);
        foundPlace.lat = parseFloat(foundPlace.lat);
        foundPlace.lon = parseFloat(foundPlace.lon);
        center = [foundPlace.lat, foundPlace.lon];

        if (foundPlace.boundingbox) {
          ne = [foundPlace.boundingbox[0], foundPlace.boundingbox[2]];
          sw = [foundPlace.boundingbox[1], foundPlace.boundingbox[3]];
          bounds = [ne, sw];
        }

        let allAddress = {};

        if (getLang() === "en") {
          if (foundPlace.address) {
            allAddress = {
              country: foundPlace.address.country,
              city: foundPlace.address.city,
              province: foundPlace.address.state,
              zipCode: foundPlace.address.postcode,
            }
          }
        } else {
          let placeDetails = await lokupForOSMElement(foundPlace.osm_type.charAt(0) + foundPlace.osm_id);
          if (placeDetails[0]?.address) {
            allAddress = {
              country: placeDetails[0].address.country,
              city: placeDetails[0].address.city,
              province: placeDetails[0].address.state,
              zipCode: placeDetails[0].address.postcode,
            }
          }
        }

        foundPlace = { center: [center[1], center[0]], allAddress }
      }
      // for analytics
      searchedPlaceData = {
        foundPlace,
        hasAddress,
        geolocation: 0,
      };
      if (center) changeUserLocation(center, name, bounds);
    }
  } catch (error) {
    log(error, "onAutocompleteAddressSelection");
  }
}

function holdit(btn, action, start, offsetTime) {
  var t;
  var offsetTimeout;

  var repeat = function () {
    action();
    t = setTimeout(repeat, start);
  };

  btn.addEventListener("mousedown", function (event) {
    if (event.which == 1) {
      event.preventDefault();
      offsetTimeout = setTimeout(repeat, offsetTime);
    }
  });

  document.addEventListener("mouseup", function (e) {
    clearTimeout(t);
    clearTimeout(offsetTimeout);
  });
}

window.pslInitGoogleMap = initGoogleMap;
